import { useAutoAnimate } from '@formkit/auto-animate/react';
export { useAutoAnimate } from '@formkit/auto-animate/react';
import { clsx } from 'clsx';
import * as React63 from 'react';
import { forwardRef } from 'react';
import { HiX, HiCheck, HiMinus, HiChevronDown, HiChevronUp, HiOutlineUpload, HiOutlineEye, HiOutlineEyeOff, HiClock, HiOutlineChevronUp, HiOutlineCheck, HiOutlineX, HiOutlineRefresh, HiOutlineTrash, HiChevronLeft, HiChevronRight, HiCheckCircle, HiInformationCircle, HiExclamation, HiXCircle } from 'react-icons/hi';
import * as Primitive from '@radix-ui/react-alert-dialog';
import { CgSpinner } from 'react-icons/cg';
import * as Primitive2 from '@radix-ui/react-checkbox';
import * as Primitive3 from '@radix-ui/react-collapsible';
import { format, addMinutes, isSameDay } from 'date-fns';
import { DayPicker as DayPicker$1 } from 'react-day-picker';
import * as Primitive4 from '@radix-ui/react-popover';
import setDate from 'date-fns/set';
import { useRifm } from 'rifm';
import * as Primitive5 from '@radix-ui/react-select';
import * as Primitive6 from '@radix-ui/react-dialog';
import * as Primitive7 from '@radix-ui/react-progress';
import { matchSorter } from 'match-sorter';
import * as MenuPrimitive from '@radix-ui/react-dropdown-menu';
import { useFloating, size, autoUpdate } from '@floating-ui/react-dom';
import { DismissableLayer } from '@radix-ui/react-dismissable-layer';
import { FocusScope } from '@radix-ui/react-focus-scope';
import { Root } from '@radix-ui/react-portal';
import { useComposedRefs } from '@reach/utils';
import { useSelect, useMultipleSelection, useCombobox } from 'downshift';
import CountryList from 'country-list-with-dial-code-and-flag';
import Highlighter from 'react-highlight-words';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as Primitive8 from '@radix-ui/react-switch';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as Primitive9 from '@radix-ui/react-toast';
import mitt from 'mitt';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var CloseButton = React63.forwardRef(
  (props, ref) => {
    const { className, defaultStyle = true, svgClass, ...rest } = props;
    const closeButtonClass = clsx(
      "close-btn",
      defaultStyle && "close-btn-default",
      className
    );
    return /* @__PURE__ */ React63.createElement("span", { className: closeButtonClass, role: "button", ...rest, ref }, /* @__PURE__ */ React63.createElement(HiX, { className: svgClass }));
  }
);
var ICONS = {
  success: {
    color: "text-emerald-500",
    icon: /* @__PURE__ */ React63.createElement(HiCheckCircle, { width: 20, height: 20, className: "w-5 h-5" })
  },
  info: {
    color: "text-blue-500",
    icon: /* @__PURE__ */ React63.createElement(HiInformationCircle, { width: 20, height: 20, className: "w-5 h-5" })
  },
  warning: {
    color: "text-yellow-500",
    icon: /* @__PURE__ */ React63.createElement(HiExclamation, { width: 20, height: 20, className: "w-5 h-5" })
  },
  danger: {
    color: "text-red-500",
    icon: /* @__PURE__ */ React63.createElement(HiXCircle, { width: 20, height: 20, className: "w-5 h-5" })
  }
};
var StatusIcon = React63.forwardRef(function StatusIcon2(props, forwardedRef) {
  const { type = "info", custom, iconColor, ...restProps } = props;
  const icon = ICONS[type];
  return /* @__PURE__ */ React63.createElement(
    "span",
    {
      ...restProps,
      className: clsx(`block ${iconColor || icon.color}`, restProps.className),
      ref: forwardedRef
    },
    custom || icon.icon
  );
});

// src/components/alert.tsx
var TYPE_MAP = {
  success: {
    backgroundColor: "bg-emerald-50 dark:bg-emerald-500",
    titleColor: "text-emerald-700 dark:text-emerald-50",
    textColor: "text-emerald-500 dark:text-emerald-50",
    iconColor: "text-emerald-400 dark:text-emerald-50",
    icon: /* @__PURE__ */ React63.createElement(HiCheckCircle, null)
  },
  info: {
    backgroundColor: "bg-blue-50 dark:bg-blue-500",
    titleColor: "text-blue-700 dark:text-blue-100",
    textColor: "text-blue-500 dark:text-blue-100",
    iconColor: "text-blue-400 dark:text-blue-100",
    icon: /* @__PURE__ */ React63.createElement(HiInformationCircle, null)
  },
  warning: {
    backgroundColor: "bg-yellow-50 dark:bg-yellow-500",
    titleColor: "text-yellow-700 dark:text-yellow-50",
    textColor: "text-yellow-500 dark:text-yellow-50",
    iconColor: "text-yellow-400 dark:text-yellow-50",
    icon: /* @__PURE__ */ React63.createElement(HiExclamation, null)
  },
  danger: {
    backgroundColor: "bg-red-50 dark:bg-red-500",
    titleColor: "text-red-700 dark:text-red-100",
    textColor: "text-red-500 dark:text-red-100",
    iconColor: "text-red-400 dark:text-red-100",
    icon: /* @__PURE__ */ React63.createElement(HiXCircle, null)
  }
};
var Alert = React63.forwardRef(
  (props, forwardedRef) => {
    const {
      type = "warning",
      title,
      className,
      children,
      showIcon = false,
      customIcon,
      onClose,
      rounded = true,
      ...rest
    } = props;
    const typeMap = TYPE_MAP[type];
    const alertDefaultClass = "p-4 relative flex";
    const alertClass = clsx(
      "alert",
      alertDefaultClass,
      typeMap.backgroundColor,
      typeMap.textColor,
      !title ? "font-semibold" : "",
      onClose ? "justify-between" : "",
      onClose && !title ? "items-center" : "",
      "rounded-lg",
      className
    );
    return /* @__PURE__ */ React63.createElement("div", { ref: forwardedRef, className: alertClass, ...rest }, /* @__PURE__ */ React63.createElement("div", { className: `flex ${title ? "" : "items-center"}` }, showIcon && /* @__PURE__ */ React63.createElement(StatusIcon, { iconColor: typeMap.iconColor, custom: customIcon, type }), /* @__PURE__ */ React63.createElement("div", { className: showIcon ? "ltr:ml-2 rtl:mr-2" : void 0 }, title ? /* @__PURE__ */ React63.createElement("div", { className: `font-semibold mb-1 ${typeMap.titleColor}` }, title) : null, children)), onClose ? /* @__PURE__ */ React63.createElement("button", { type: "button", onClick: onClose }, /* @__PURE__ */ React63.createElement(CloseButton, { defaultStyle: false })) : null);
  }
);
var AlertDialog = Object.assign({}, Primitive, {
  Content: React63.forwardRef(
    function StyledContent(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        Primitive.Content,
        {
          ...props,
          ref: forwardedRef,
          className: clsx(
            "fixed bg-white px-4 py-2 rounded shadow top-20 max-h-[calc(100vh-6rem)] overflow-y-auto left-1/2 -translate-x-1/2",
            props.className
          )
        }
      );
    }
  ),
  Overlay: React63.forwardRef(
    function StyledOverlay(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        Primitive.Overlay,
        {
          ...props,
          ref: forwardedRef,
          className: clsx("fixed inset-0 bg-gray-500 opacity-70", props.className)
        }
      );
    }
  ),
  Title: React63.forwardRef(function StyledTitle(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive.Title,
      {
        ...props,
        ref: forwardedRef,
        className: clsx("text-lg font-medium pb-2 min-w-[15rem] sm:min-w-[30rem]", props.className)
      }
    );
  }),
  Footer: (props) => /* @__PURE__ */ React63.createElement("div", { ...props, className: clsx("flex gap-3 pt-2", props.className) })
});

// src/utils/constant.ts
var SIZES = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg"
};
var heightBySize = {
  [SIZES.XS]: "h-7",
  [SIZES.SM]: "h-9",
  [SIZES.MD]: "h-11",
  [SIZES.LG]: "h-14"
};
var widthBySize = {
  [SIZES.XS]: "w-7",
  [SIZES.SM]: "w-9",
  [SIZES.MD]: "w-11",
  [SIZES.LG]: "w-14"
};
var LAYOUT = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  INLINE: "inline"
};

// src/components/avatar.tsx
var Avatar = ({ size = "sm", ...props }) => {
  if (props.isLoading) {
    return /* @__PURE__ */ React63.createElement(AvatarText, { ...props, size, isLoading: true }, " ");
  }
  return props.imgSrc ? /* @__PURE__ */ React63.createElement(
    "img",
    {
      src: props.imgSrc,
      alt: props.text,
      className: clsx(
        "block object-cover rounded-full bg-white",
        heightBySize[size],
        widthBySize[size],
        props.className
      ),
      width: props.width,
      height: props.height
    }
  ) : props.text ? /* @__PURE__ */ React63.createElement(AvatarText, { ...props, size }, abbreviate(props.text)) : null;
};
var AvatarText = (props) => /* @__PURE__ */ React63.createElement(
  "span",
  {
    className: clsx(
      "flex items-center justify-center text-sm text-white rounded-full",
      props.isLoading ? "bg-gray-300" : "bg-gray-600",
      heightBySize[props.size],
      widthBySize[props.size],
      props.className
    )
  },
  props.children
);
var abbreviate = (text) => {
  const parts = text.trim().split(/\s+/);
  return (parts.length > 2 ? [parts[0], parts[parts.length - 1]] : parts).map((part) => part[0].toUpperCase()).join("");
};
var BadgeImpl = React63.forwardRef(function Badge(props, ref) {
  const {
    children,
    maxCount = 99,
    className,
    innerClass,
    badgeStyle,
    color = "primary",
    ...rest
  } = props;
  const dot = typeof children !== "number" && typeof children !== "string";
  return /* @__PURE__ */ React63.createElement("span", { className: clsx("relative flex", className), ref, ...rest }, /* @__PURE__ */ React63.createElement(
    "span",
    {
      className: clsx(
        dot ? "rounded-full text-xs w-2 h-2" : "rounded-full px-2 py-0.5 text-xs",
        colors[color],
        innerClass,
        "absolute z-10 transform top-0 ltr:translate-x-2/4 rtl:-translate-x-2/4 -translate-y-2/4 ltr:right-0 rtl:left-0;"
      ),
      style: badgeStyle
    },
    typeof children === "number" && children > maxCount ? `${maxCount}+` : children
  ));
});
var colors = {
  primary: "bg-primary-600 text-white",
  red: "bg-red-600 text-white"
};
var Badge2 = Object.assign(BadgeImpl, {
  colors: Object.keys(colors)
});
var createNamedContext = (defaultValue, displayName) => {
  const Context = React63.createContext(defaultValue);
  Context.displayName = displayName;
  return Context;
};

// src/context/config.ts
var ConfigContext = createNamedContext(
  {
    direction: "ltr",
    mode: "light",
    locale: "en",
    cardBordered: false,
    controlSize: SIZES.MD,
    navMode: "light"
  },
  "ConfigContext"
);
var ConfigProvider = ConfigContext.Provider;
var useConfig = () => React63.useContext(ConfigContext);
var FormStyleContext = createNamedContext(
  {
    labelWidth: 100,
    layout: LAYOUT.VERTICAL,
    size: SIZES.MD
  },
  "FormStyleContext"
);
FormStyleContext.Provider;
var useFormStyle = () => React63.useContext(FormStyleContext);
var InputStyleContext = createNamedContext({}, "InputStyleContext");
InputStyleContext.Provider;
var useInputStyle = () => React63.useContext(InputStyleContext);
var Spinner = ({
  className,
  enableTheme,
  isSpining = true,
  size = 20,
  style,
  ...rest
}) => {
  const spinnerStyle = {
    height: size,
    width: size,
    ...style
  };
  const spinnerClass = clsx(
    isSpining && "animate-spin",
    enableTheme && "text-primary-600",
    className
  );
  const spinnerProps = {
    style: spinnerStyle,
    className: spinnerClass,
    ...rest
  };
  return /* @__PURE__ */ React63.createElement(CgSpinner, { ...spinnerProps });
};

// src/components/button.tsx
var Button = React63.forwardRef(function Button2({
  children: providedChildren,
  size,
  shape = "round",
  variant = "default",
  block,
  icon,
  endIcon,
  className: providedClassName,
  disabled,
  loading,
  active,
  type = "button",
  render,
  ...rest
}, forwardedRef) {
  const { controlSize } = useConfig();
  const formControlSize = useFormStyle().size;
  const inputGroupSize = useInputStyle().size;
  const sizeIconClass = "inline-flex items-center justify-center";
  const buttonSize = size || inputGroupSize || formControlSize || controlSize;
  const getButtonSize = () => {
    let sizeClass = "";
    switch (buttonSize) {
      case SIZES.LG:
        sizeClass = clsx(
          heightBySize.lg,
          icon && !providedChildren ? `${widthBySize.lg} ${sizeIconClass} text-2xl` : "px-8 py-2 text-base"
        );
        break;
      case SIZES.SM:
        sizeClass = clsx(
          heightBySize.sm,
          icon && !providedChildren ? `${widthBySize.sm} ${sizeIconClass} text-lg` : "px-3 py-2 text-sm"
        );
        break;
      case SIZES.XS:
        sizeClass = clsx(
          heightBySize.xs,
          icon && !providedChildren ? `${widthBySize.xs} ${sizeIconClass} text-base` : "px-3 py-1 text-xs"
        );
        break;
      default:
        sizeClass = clsx(
          heightBySize.md,
          icon && !providedChildren ? `${widthBySize.md} ${sizeIconClass} text-xl` : "px-8 py-2"
        );
        break;
    }
    return sizeClass;
  };
  const disabledClass = "opacity-50 cursor-not-allowed";
  const solidColor = () => {
    const btn = {
      bgColor: active ? `bg-primary-700` : `bg-primary-600`,
      textColor: "text-white",
      hoverColor: active ? "" : `hover:bg-primary-500`,
      activeColor: `active:bg-primary-700`
    };
    return getBtnColor(btn);
  };
  const twoToneColor = () => {
    const btn = {
      bgColor: active ? `bg-primary-200 dark:bg-primary-50` : `bg-primary-50 dark:bg-primary-500 dark:bg-opacity-20`,
      textColor: `text-primary-600 dark:text-primary-50`,
      hoverColor: active ? "" : `hover:bg-primary-100 dark:hover:bg-primary-500 dark:hover:bg-opacity-30`,
      activeColor: `active:bg-primary-200 dark:active:bg-primary-500 dark:active:bg-opacity-40`
    };
    return getBtnColor(btn);
  };
  const defaultColor = () => {
    const btn = {
      bgColor: active ? `bg-gray-100 border border-gray-300 dark:bg-gray-500 dark:border-gray-500` : `bg-white border border-gray-300 dark:bg-gray-700 dark:border-gray-700`,
      textColor: `text-gray-600 dark:text-gray-100`,
      hoverColor: active ? "" : `hover:bg-gray-50 dark:hover:bg-gray-600`,
      activeColor: `active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500`
    };
    return getBtnColor(btn);
  };
  const plainColor = () => {
    const btn = {
      bgColor: active ? `bg-gray-100 dark:bg-gray-500` : "bg-transparent border border-transparent",
      textColor: `text-gray-600 dark:text-gray-100`,
      hoverColor: active ? "" : `hover:bg-gray-50 dark:hover:bg-gray-600`,
      activeColor: `active:bg-gray-100 dark:active:bg-gray-500 dark:active:border-gray-500`
    };
    return getBtnColor(btn);
  };
  const dangerColor = () => {
    const btn = {
      bgColor: active ? `bg-red-700` : `bg-red-600`,
      textColor: "text-white",
      hoverColor: active ? "" : `hover:bg-red-500`,
      activeColor: `active:bg-red-700`
    };
    return getBtnColor(btn);
  };
  const getBtnColor = ({
    bgColor,
    hoverColor,
    activeColor,
    textColor
  }) => {
    return `${bgColor} ${disabled || loading ? disabledClass : hoverColor + " " + activeColor} ${textColor}`;
  };
  const btnColor = () => {
    switch (variant) {
      case "solid":
        return solidColor();
      case "twoTone":
        return twoToneColor();
      case "plain":
        return plainColor();
      case "danger":
        return dangerColor();
      case "default":
        return defaultColor();
      default:
        return defaultColor();
    }
  };
  const renderChildren = () => {
    if (loading && providedChildren) {
      return /* @__PURE__ */ React63.createElement("span", { className: "flex items-center justify-center" }, /* @__PURE__ */ React63.createElement(Spinner, { enableTheme: false, className: "mr-1" }), providedChildren, endIcon);
    }
    if (icon && !providedChildren && loading) {
      return /* @__PURE__ */ React63.createElement(Spinner, { enableTheme: false });
    }
    if (icon && !providedChildren && !loading) {
      return /* @__PURE__ */ React63.createElement(React63.Fragment, null, icon);
    }
    if ((icon || endIcon) && providedChildren && !loading) {
      return /* @__PURE__ */ React63.createElement("span", { className: "flex items-center justify-center gap-2" }, icon && /* @__PURE__ */ React63.createElement("span", { className: "text-lg" }, icon), /* @__PURE__ */ React63.createElement("span", { className: "ltr:ml-1 rtl:mr-1" }, providedChildren), endIcon);
    }
    return /* @__PURE__ */ React63.createElement(React63.Fragment, null, providedChildren);
  };
  const className = clsx(
    "inline-block font-semibold focus:outline-none focus-visible:ring focus-visible:ring-primary-200 whitespace-nowrap",
    btnColor(),
    {
      round: "rounded-md",
      circle: "rounded-full",
      none: "rounded-none"
    }[shape],
    getButtonSize(),
    providedClassName,
    block && "w-full"
  );
  const children = renderChildren();
  if (render) {
    return render({
      className,
      children,
      ref: forwardedRef
    });
  }
  return /* @__PURE__ */ React63.createElement(
    "button",
    {
      ref: forwardedRef,
      className,
      type,
      ...rest,
      disabled: disabled || loading
    },
    children
  );
});

// src/utils/type-guard.ts
var isDefined = (value) => typeof value !== "undefined";
var isNil = (value) => value == null;
var isString = (value) => typeof value === "string";
var isNumber = (value) => typeof value === "number";
var isFunction = (value) => typeof value === "function";
var isObject = (value) => !isNil(value) && typeof value === "object";
var isPrimitive = (value) => /^(b|st|n)/.test(typeof value);

// src/components/card.tsx
var CardImpl = React63.forwardRef(function Card({ children, className, bordered: providedBordered, header, footer, body, ...rest }, ref) {
  const { cardBordered } = useConfig();
  const bordered = isDefined(providedBordered) ? providedBordered : cardBordered;
  const cardClass = clsx(
    "bg-white rounded-lg dark:bg-gray-800",
    className,
    bordered ? `border border-gray-200 dark:border-gray-600` : `shadow border-b border-gray-200 dark:border-gray-600 dark:border-none`,
    isFunction(rest.onClick) && "cursor-pointer user-select-none"
  );
  return /* @__PURE__ */ React63.createElement("div", { className: cardClass, ref, ...rest }, header && /* @__PURE__ */ React63.createElement(CardHeader, null, header), body && /* @__PURE__ */ React63.createElement(CardBody, null, body), children, footer && /* @__PURE__ */ React63.createElement(CardFooter, null, footer));
});
var CardHeader = ({ bordered, extra, children, ...props }) => /* @__PURE__ */ React63.createElement(
  "div",
  {
    ...props,
    className: clsx(
      "py-3 px-5",
      bordered && "border-b border-gray-200 dark:border-gray-600",
      extra && "flex justify-between items-center",
      props.className
    )
  },
  children,
  extra && /* @__PURE__ */ React63.createElement("div", null, extra)
);
var CardBody = (props) => /* @__PURE__ */ React63.createElement("div", { ...props, className: clsx("p-5", props.className) });
var CardFooter = ({ bordered, ...props }) => /* @__PURE__ */ React63.createElement(
  "div",
  {
    ...props,
    className: clsx(
      "py-3 px-5 rounded-bl-lg rounded-br-lg",
      bordered && "border-t border-gray-200 dark:border-gray-600",
      props.className
    )
  }
);
var Card2 = Object.assign(CardImpl, {
  Header: CardHeader,
  Body: CardBody,
  Footer: CardFooter
});
var Checkbox = React63.forwardRef(
  (props, forwardedRef) => {
    const { iconSize, ...rest } = props;
    return /* @__PURE__ */ React63.createElement(
      Primitive2.Root,
      {
        ...rest,
        className: clsx(
          "group flex justify-center items-center w-6 h-6 border border-gray-300 rounded-md",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          props.disabled && "bg-gray-100 cursor-not-allowed",
          props.className
        ),
        ref: forwardedRef
      },
      /* @__PURE__ */ React63.createElement(Primitive2.CheckboxIndicator, null, /* @__PURE__ */ React63.createElement(
        HiCheck,
        {
          size: iconSize,
          className: "text-primary-600 group-[[data-disabled]]:text-gray-400 group-[[data-state=indeterminate]]:hidden"
        }
      ), /* @__PURE__ */ React63.createElement(
        HiMinus,
        {
          size: iconSize,
          className: "text-primary-600 group-[[data-disabled]]:text-gray-400 hidden group-[[data-state=indeterminate]]:block"
        }
      ))
    );
  }
);
var DEFAULT = {
  inputId: "",
  status: void 0,
  layout: "horizontal"
};
var FormControlContext = React63.createContext(DEFAULT);
FormControlContext.displayName = "FormControlContext";
var FormControlContextProvider = FormControlContext.Provider;
var useFormControl = () => React63.useContext(FormControlContext);
var useFormControlSize = (providedSize) => {
  const config = useConfig();
  const formStyleSize = useFormStyle().size;
  const inputGroupSize = useInputStyle().size;
  return providedSize || inputGroupSize || formStyleSize || config.controlSize;
};

// src/components/checkbox-group.tsx
var CheckboxGroup = React63.forwardRef(
  function CheckboxGroup2(props, forwardedRef) {
    const { inputId } = useFormControl();
    const fallbackId = React63.useId();
    const { value = [] } = props;
    const { orientation = "vertical", id = inputId || fallbackId } = props;
    return /* @__PURE__ */ React63.createElement(
      "div",
      {
        className: clsx(
          "flex gap-3",
          {
            vertical: "flex-col",
            horizontal: "flex-row"
          }[orientation],
          props.className
        )
      },
      props.options.map((option, index) => /* @__PURE__ */ React63.createElement("div", { className: "flex items-center gap-3", key: index }, /* @__PURE__ */ React63.createElement(
        Checkbox,
        {
          id: `${id}-${index}`,
          value: option.value,
          name: props.name,
          disabled: props.disabled,
          checked: value.includes(option.value),
          onCheckedChange: () => {
            if (props.onValue) {
              props.onValue(
                value.includes(option.value) ? value.filter((v) => v !== option.value) : value.concat(option.value)
              );
            }
          },
          ref: index === 0 ? forwardedRef : void 0
        }
      ), /* @__PURE__ */ React63.createElement(
        "label",
        {
          htmlFor: `${id}-${index}`,
          className: clsx("text-sm select-none", option.displayLabel && "sr-only")
        },
        option.label
      ), option.displayLabel && /* @__PURE__ */ React63.createElement("div", { "aria-hidden": true }, option.displayLabel)))
    );
  }
);
var FieldGroup = ({
  children,
  fieldId,
  status,
  layout = "responsive",
  ...props
}) => {
  const reactId = React63.useId();
  const content = /* @__PURE__ */ React63.createElement(
    FormControlContextProvider,
    {
      value: React63.useMemo(
        () => ({
          inputId: fieldId || reactId,
          status,
          layout
        }),
        [fieldId, status, layout]
      )
    },
    children
  );
  return /* @__PURE__ */ React63.createElement("div", { ...props, className: clsx(classByLayout[layout], props.className) }, layout === "responsive" ? /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: clsx(
        classByLayout.vertical,
        "@lg/field:flex-row @lg/field:items-center @lg/field:gap-3"
      )
    },
    content
  ) : content);
};
var classByLayout = {
  horizontal: "flex items-start gap-3",
  vertical: "flex flex-col gap-1",
  responsive: "@container/field"
};
var Label = ({ children, showRequiredIndicator, ...props }) => {
  const { inputId, status, layout } = useFormControl();
  return /* @__PURE__ */ React63.createElement(
    "label",
    {
      ...props,
      htmlFor: props.htmlFor || inputId,
      className: clsx(
        "flex items-center text-sm",
        layout === "horizontal" && "w-36 flex-shrink-0",
        layout === "responsive" && "@lg/field:w-36 @md/field:flex-shrink-0",
        status === "danger" ? "text-red-500" : "text-gray-600",
        props.className
      )
    },
    children,
    showRequiredIndicator && /* @__PURE__ */ React63.createElement("span", { className: "text-red-700" }, "*")
  );
};

// src/components/checkbox-field.tsx
var CheckboxField = React63.forwardRef(
  function CheckboxField2({ id, status, label, layout, required, renderError, ...props }, forwardedRef) {
    const fallbackId = React63.useId();
    const ensuredId = id || fallbackId;
    const labelId = `${ensuredId}__label`;
    return /* @__PURE__ */ React63.createElement(
      FieldGroup,
      {
        fieldId: ensuredId,
        status,
        layout,
        role: "group",
        "aria-labelledby": labelId
      },
      label && /* @__PURE__ */ React63.createElement(Label, { className: "self-start", id: labelId, showRequiredIndicator: required }, label),
      /* @__PURE__ */ React63.createElement("div", null, /* @__PURE__ */ React63.createElement(CheckboxGroup, { ...props, ref: forwardedRef }), renderError)
    );
  }
);
var Content3 = React63.forwardRef(
  function Content4(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive3.Content,
      {
        ...props,
        ref: forwardedRef,
        className: clsx(
          "overflow-hidden data-[state=open]:animate-[collapseSlideDown_100ms_ease-out]",
          "data-[state=closed]:animate-[collapseSlideUp_100ms_ease-in]",
          props.className
        )
      }
    );
  }
);
var Collapsible = Object.assign({}, Primitive3, {
  Content: Content3
});
var formatDate = (date, {
  formatType = "dateOnly",
  format: format$1 = formatType === "dateOnly" ? FORMAT_STRING.dayOnly : FORMAT_STRING.dayAndTime
} = {}) => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  return isNaN(dateObj.getTime()) ? date : format(dateObj, format$1);
};
var formatDateUtc = (date) => {
  const d = typeof date === "string" ? new Date(date) : date;
  return format(addMinutes(d, d.getTimezoneOffset()), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
};
var formatDateRange = (dateRange, dayOnly) => {
  const { from, to } = dateRange;
  if (isDefined(from)) {
    const fromDisplay = formatDate(from, { formatType: dayOnly ? "dateOnly" : "dateAndTime" });
    if (!isDefined(to) || isNil(to)) {
      return `from ${fromDisplay}`;
    }
    if (isSameDay(from, to)) {
      const dayOnlyDisplay = formatDate(from, { formatType: "dateOnly" });
      if (dayOnly) {
        return dayOnlyDisplay;
      }
      const fromTime = format(from, FORMAT_STRING.timeOnly);
      const toTime = format(to, FORMAT_STRING.timeOnly);
      if (fromTime === toTime) {
        return formatDate(from, { formatType: "dateAndTime" });
      }
      return `${dayOnlyDisplay}, ${fromTime} - ${toTime}`;
    } else {
      const toDisplay = formatDate(to, { formatType: dayOnly ? "dateOnly" : "dateAndTime" });
      return `${fromDisplay} - ${toDisplay}`;
    }
  }
  return "";
};
var FORMAT_STRING = {
  dayOnly: "d MMM yyyy",
  dayAndTime: "d MMM yyyy, h:mm a",
  timeOnly: "h:mm a"
};
var cssHooks = {
  today: "data__day-today",
  selected: "data__day-selected"
};
var DayPicker = (props) => /* @__PURE__ */ React63.createElement(DayPicker$1, { classNames: classNames3, ...props });
var classNames3 = {
  vhidden: "sr-only",
  caption: "flex justify-center items-center h-10",
  root: "inline-block text-gray-800",
  months: "flex gap-4 relative px-4",
  caption_label: "inline-flex items-center gap-2 text-base px-1",
  caption_dropdowns: "flex flex-row-reverse justify-between gap-4 w-full px-2",
  dropdown_month: "relative inline-flex items-center",
  dropdown: "absolute inset-0 opacity-0 z-10",
  dropdown_year: "relative inline-flex items-center",
  nav_button: "inline-flex justify-center items-center absolute top-0 w-10 h-10 rounded-full text-gray-600 hover:bg-gray-100",
  nav_button_next: "right-0",
  nav_button_previous: "left-0",
  table: "border-collapse border-spacing-0",
  head_cell: "w-10 h-10 text-sm uppercase align-middle text-center",
  cell: "w-10 h-10 align-middle text-center border-0 px-0",
  day: "inline-flex justify-center items-center w-10 h-10 rounded-full transition-colors hover:bg-primary-100 hover:text-gray-800 focus:outline-none focus-visible:ring focus-visible:ring-primary-300 focus-visible:ring-opacity-50 active:bg-primary-600 active:text-white",
  day_selected: `${cssHooks.selected} text-white bg-primary-500 hover:text-white hover:bg-primary-800`,
  day_today: `${cssHooks.today} font-bold`,
  day_disabled: "opacity-25 hover:bg-white active:bg-white active:text-gray-800",
  day_outside: "enabled:opacity-50",
  day_range_middle: "rounded-none",
  day_range_end: "rounded-l-none rounded-r-full",
  day_range_start: "rounded-r-none rounded-l-full",
  day_hidden: "hidden"
};
var InputButton = React63.forwardRef(
  function InputButton2({ size, className, appearFocus, appearEmpty, ...props }, forwardedRef) {
    const inputSize = useFormControlSize(size);
    return /* @__PURE__ */ React63.createElement(
      "button",
      {
        type: "button",
        className: clsx(
          "flex items-center w-full px-3 text-left border border-gray-300 rounded-md",
          inputSize === "md" && "py-2",
          inputSize === "lg" && "text-lg",
          heightBySize[inputSize],
          appearFocus && "border-primary-600 ring-2 ring-primary-500 ring-opacity-50",
          appearEmpty && "text-gray-400",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          props.disabled && "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70",
          className
        ),
        ...props,
        ref: forwardedRef
      }
    );
  }
);
var Content6 = React63.forwardRef(
  function PopoverContent(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive4.Content,
      {
        style: {
          transformOrigin: "var(--radix-popover-content-transform-origin)"
        },
        ...props,
        className: clsx(
          "p-1 bg-white rounded shadow-lg animate-[scalein_100ms_ease-out]",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Popover = Object.assign({}, Primitive4, { Content: Content6 });

// src/components/date-range-selector.tsx
var DateRangeSelector = React63.forwardRef(
  function DateRangeSelector2({ name, id, placeholder = "Select date", value, onValue, disabled, size, required, ...props }, forwardedRef) {
    const [open, setOpen] = React63.useState(false);
    const valueString = React63.useMemo(() => value ? formatDateRange(value, true) : "", [value]);
    const contentRef = React63.useRef(null);
    const { inputId } = useFormControl();
    const [hasAutoClosed, setHasAutoClosed] = React63.useState(false);
    return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement("input", { type: "hidden", value: valueString, name, required }), /* @__PURE__ */ React63.createElement(Popover.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React63.createElement(Popover.Trigger, { asChild: true }, /* @__PURE__ */ React63.createElement(
      InputButton,
      {
        id: id || inputId,
        size,
        appearFocus: open,
        appearEmpty: !value || !value.from,
        disabled,
        ref: forwardedRef
      },
      valueString || placeholder
    )), /* @__PURE__ */ React63.createElement(Popover.Portal, null, /* @__PURE__ */ React63.createElement(
      Popover.Content,
      {
        align: "start",
        sideOffset: 2,
        onOpenAutoFocus: (ev) => {
          ev.preventDefault();
          if (contentRef.current) {
            const selected = contentRef.current.querySelector(`.${cssHooks.selected}`);
            const target = selected || contentRef.current.querySelector(`.${cssHooks.today}`);
            if (target && target instanceof HTMLElement) {
              target.focus();
            }
          }
        },
        ref: contentRef
      },
      /* @__PURE__ */ React63.createElement(
        DayPicker,
        {
          mode: "range",
          selected: value,
          onSelect: (newRange) => {
            onValue(newRange);
            if (!hasAutoClosed && value && !value.to && newRange && newRange.to) {
              setHasAutoClosed(true);
              setOpen(false);
            }
          },
          ...props
        }
      )
    ))));
  }
);

// src/components/date-range-field.tsx
var DateRangeField = React63.forwardRef(
  function DateRangeField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(DateRangeSelector, { ...props, ref: forwardedRef }));
  }
);
var DaySelector = React63.forwardRef(
  function DaySelector2({
    name,
    id,
    placeholder = "Select date",
    value,
    parseValue: parseValue2,
    onValue,
    disabled,
    min,
    max,
    size,
    monthNavigation = "buttons",
    fromYear = monthNavigation === "dropdown" ? min ? min.getFullYear() : 1960 : void 0,
    toYear = monthNavigation === "dropdown" ? max ? max.getFullYear() : 2050 : void 0,
    className,
    ...props
  }, forwardedRef) {
    const [open, setOpen] = React63.useState(false);
    const valueString = React63.useMemo(() => value ? formatDate(value) : "", [value]);
    const contentRef = React63.useRef(null);
    const computedDisabled = React63.useMemo(() => {
      const result = [];
      if (min) {
        result.push({
          before: min
        });
      }
      if (max) {
        result.push({
          after: max
        });
      }
      return result;
    }, [min, max]);
    const { inputId } = useFormControl();
    return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement("input", { type: "hidden", value: valueString, name, required: props.required }), /* @__PURE__ */ React63.createElement(Popover.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React63.createElement(Popover.Trigger, { asChild: true }, /* @__PURE__ */ React63.createElement(
      InputButton,
      {
        id: id || inputId,
        ref: forwardedRef,
        appearFocus: open,
        appearEmpty: !value,
        disabled,
        size,
        className
      },
      valueString || placeholder
    )), /* @__PURE__ */ React63.createElement(Popover.Portal, null, /* @__PURE__ */ React63.createElement(
      Popover.Content,
      {
        style: { zIndex: 999999 },
        align: "start",
        sideOffset: 2,
        onOpenAutoFocus: (ev) => {
          ev.preventDefault();
          if (contentRef.current) {
            const selected = contentRef.current.querySelector(`.${cssHooks.selected}`);
            const target = selected || contentRef.current.querySelector(`.${cssHooks.today}`);
            if (target && target instanceof HTMLElement) {
              target.focus();
            }
          }
        },
        ref: contentRef
      },
      /* @__PURE__ */ React63.createElement(
        DayPicker,
        {
          mode: "single",
          selected: value,
          onSelect: (val) => {
            onValue(parseValue2 ? parseValue2(val) : val);
            setOpen(false);
          },
          disabled: computedDisabled,
          captionLayout: monthNavigation,
          fromYear,
          toYear,
          ...props
        }
      )
    ))));
  }
);

// src/utils/fn-lib.ts
function callAll(...fns) {
  return function callAllFns() {
    const arg = arguments;
    fns.forEach((fn) => typeof fn === "function" && fn.apply(null, arg));
  };
}

// src/utils/feature-check.ts
var featureCheck = {
  stringRepeat: !!String.prototype.repeat,
  stringPadStart: !!String.prototype.padStart,
  stringPadEnd: !!String.prototype.padEnd,
  intlNumberFormat: !!(typeof Intl === "object" && Intl && typeof Intl.NumberFormat === "function"),
  intListFormat: !!(typeof Intl === "object" && Intl && typeof Intl.ListFormat === "function")
};

// src/utils/string.ts
var stringRepeat = (charToRepeat, count) => {
  if (featureCheck.stringRepeat) {
    return charToRepeat.repeat(count);
  }
  if (count < 0 || count === Infinity) {
    throw RangeError(`Repeat count must be between 0 and Infinity`);
  }
  let result = "";
  for (let index = 0; index < count; index++) {
    result += charToRepeat;
  }
  return result;
};
var padStart = (oriString, maxLength, fillString = " ") => {
  if (featureCheck.stringPadStart) {
    return oriString.padStart(maxLength, fillString);
  }
  const requiredPadding = maxLength - oriString.length;
  if (requiredPadding <= 0) {
    return oriString;
  }
  return stringRepeat(fillString, requiredPadding) + oriString;
};
var padEnd = (oriString, maxLength, fillString = " ") => {
  if (featureCheck.stringPadEnd) {
    return oriString.padEnd(maxLength, fillString);
  }
  const requiredPadding = maxLength - oriString.length;
  if (requiredPadding <= 0) {
    return oriString;
  }
  return oriString + stringRepeat(fillString, requiredPadding);
};
var forwardRefWithGenerics = forwardRef;

// src/components/select.tsx
var Select = forwardRefWithGenerics(function Select2({
  options,
  size,
  placeholder,
  disabled,
  value,
  onValue,
  id,
  className,
  noBorder,
  footer,
  ...selectProps
}, forwardedRef) {
  const selectSize = useFormControlSize(size);
  const { inputId } = useFormControl();
  const normalizedValue = isNumber(value) ? String(value) : value;
  const normalizedOptions = options.map((option) => ({
    ...option,
    domValue: String(option.value)
  }));
  return /* @__PURE__ */ React63.createElement(
    Primitive5.Root,
    {
      ...selectProps,
      value: normalizedValue,
      onValueChange: (value2) => {
        if (onValue) {
          const matchedOption = normalizedOptions.find((opt) => opt.domValue === value2);
          if (matchedOption) {
            onValue(matchedOption.value);
          } else {
            onValue(value2);
          }
        }
      }
    },
    /* @__PURE__ */ React63.createElement(
      Primitive5.Trigger,
      {
        className: clsx(
          "flex justify-between items-center w-full rounded-md",
          !noBorder && "border border-gray-300",
          selectSize === "lg" && "text-lg",
          heightBySize[selectSize],
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          "data-[placeholder]:text-gray-400",
          disabled ? "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70" : "bg-white",
          className
        ),
        id: id || inputId,
        disabled,
        ref: forwardedRef
      },
      /* @__PURE__ */ React63.createElement("span", { className: "block px-3 py-2" }, /* @__PURE__ */ React63.createElement(Primitive5.Value, { placeholder })),
      /* @__PURE__ */ React63.createElement("span", { className: "p-2 text-xl" }, /* @__PURE__ */ React63.createElement(Primitive5.Icon, { asChild: true }, /* @__PURE__ */ React63.createElement("span", null, /* @__PURE__ */ React63.createElement(HiChevronDown, { className: "text-gray-400", width: 20, height: 20 }))))
    ),
    /* @__PURE__ */ React63.createElement(Primitive5.Portal, null, /* @__PURE__ */ React63.createElement(
      Primitive5.Content,
      {
        style: { zIndex: 999999 },
        className: "bg-white border border-gray-50 shadow-lg rounded"
      },
      /* @__PURE__ */ React63.createElement(Primitive5.ScrollUpButton, null, /* @__PURE__ */ React63.createElement(HiChevronUp, null)),
      /* @__PURE__ */ React63.createElement(Primitive5.Viewport, null, normalizedOptions.map((option, index) => /* @__PURE__ */ React63.createElement(
        Primitive5.Item,
        {
          className: clsx(
            "flex justify-between items-center px-2 py-1.5 data-[state=checked]:bg-gray-100",
            "data-[highlighted]:bg-gray-50 data-[highlighted]:outline-none"
          ),
          value: option.domValue,
          key: index
        },
        /* @__PURE__ */ React63.createElement(
          Primitive5.ItemText,
          null,
          option.label
        ),
        /* @__PURE__ */ React63.createElement(Primitive5.ItemIndicator, null, /* @__PURE__ */ React63.createElement(HiCheck, { className: "text-primary-600" }))
      )), /* @__PURE__ */ React63.createElement(Primitive5.ScrollDownButton, null, /* @__PURE__ */ React63.createElement(HiChevronDown, null))),
      footer && /* @__PURE__ */ React63.createElement("section", { className: "p-2 border-t border-gray-100 w-full" }, footer)
    ))
  );
});
var TextInput = React63.forwardRef(function TextInput2({ className, prefix, size, suffix, style, onValue, onChange, noBorder, ...inputProps }, ref) {
  const [prefixGutter, setPrefixGutter] = React63.useState(0);
  const [suffixGutter, setSuffixGutter] = React63.useState(0);
  const { direction } = useConfig();
  const inputSize = useFormControlSize(size);
  const { inputId } = useFormControl();
  const prefixNode = React63.useRef(null);
  const suffixNode = React63.useRef(null);
  const getAffixSize = () => {
    if (!prefixNode.current && !suffixNode.current) {
      return;
    }
    const prefixNodeWidth = prefixNode?.current?.offsetWidth;
    const suffixNodeWidth = suffixNode?.current?.offsetWidth;
    if (isNil(prefixNodeWidth) && isNil(suffixNodeWidth)) {
      return;
    }
    if (prefixNodeWidth) {
      setPrefixGutter(prefixNodeWidth);
    }
    if (suffixNodeWidth) {
      setSuffixGutter(suffixNodeWidth);
    }
  };
  React63.useEffect(() => {
    getAffixSize();
  }, [prefix, suffix]);
  const affixGutterStyle = () => {
    const leftGutter = `${remToPxConvertion(prefixGutter) + 1}rem`;
    const rightGutter = `${remToPxConvertion(suffixGutter) + 1}rem`;
    const gutterStyle = {};
    if (direction === "ltr") {
      if (prefix) {
        gutterStyle.paddingLeft = leftGutter;
      }
      if (suffix) {
        gutterStyle.paddingRight = rightGutter;
      }
    }
    if (direction === "rtl") {
      if (prefix) {
        gutterStyle.paddingRight = leftGutter;
      }
      if (suffix) {
        gutterStyle.paddingLeft = rightGutter;
      }
    }
    return gutterStyle;
  };
  const inputNode = inputProps?.type === "textarea" ? /* @__PURE__ */ React63.createElement(
    "textarea",
    {
      style: { ...affixGutterStyle(), ...style },
      className: clsx(
        "w-full py-2 px-3 rounded-md",
        !noBorder && "border border-gray-300",
        heightBySize[inputSize],
        "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
        !prefix && !suffix ? className : "",
        inputProps.disabled && "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70"
      ),
      ref,
      onChange: callAll(onChange, onValue && ((ev) => onValue(ev.target.value))),
      ...inputProps,
      id: inputProps.id || inputId
    }
  ) : /* @__PURE__ */ React63.createElement(
    "input",
    {
      type: "text",
      style: { ...affixGutterStyle(), ...style },
      className: clsx(
        "w-full py-2 px-3 rounded-md",
        !noBorder && "border border-gray-300",
        inputSize === "lg" && "text-lg",
        heightBySize[inputSize],
        "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
        !prefix && !suffix ? className : "",
        inputProps.disabled && "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70"
      ),
      ref,
      onChange: callAll(onChange, onValue && ((ev) => onValue(ev.target.value))),
      ...inputProps,
      id: inputProps.id || inputId
    }
  );
  if (prefix || suffix) {
    return /* @__PURE__ */ React63.createElement("div", { className: clsx("relative w-full flex", className) }, prefix ? /* @__PURE__ */ React63.createElement(
      "div",
      {
        className: "absolute top-2/4 transform -translate-y-2/4 left-2.5 rtl:right-2.5",
        ref: prefixNode
      },
      prefix
    ) : null, inputNode, suffix ? /* @__PURE__ */ React63.createElement(
      "div",
      {
        className: "absolute top-2/4 transform -translate-y-2/4 right-2.5 rtl:left-2.5 flex",
        ref: suffixNode
      },
      suffix
    ) : null);
  } else {
    return inputNode;
  }
});
var remToPxConvertion = (pixel) => 0.0625 * pixel;

// src/components/time-input.tsx
var TimeInput = ({
  onValue,
  hours,
  minutes,
  includeSeconds,
  seconds,
  wrapperClass,
  ...props
}) => {
  const isPm = !!hours && hours >= 12;
  const displayedHour = isDefined(hours) ? hours % 12 === 0 ? 12 : isPm ? hours - 12 : hours : hours;
  const displayedValue = React63.useMemo(() => {
    if (!isDefined(displayedHour) && !includeSeconds) {
      return "";
    }
    const valueWithoutSeconds = `${padStart(
      (displayedHour || 0).toString(),
      2,
      "0"
    )}:${padStart((minutes || 0).toString(), 2, "0")}`;
    return includeSeconds ? `${valueWithoutSeconds}:${padStart((seconds || 0).toString(), 2, "0")}` : valueWithoutSeconds;
  }, [displayedHour, minutes, seconds, includeSeconds]);
  const [v, setV] = React63.useState(displayedValue);
  React63.useEffect(() => {
    setV(displayedValue);
  }, [displayedValue]);
  const handleChangeHour = (hours2) => {
    onValue(
      includeSeconds ? {
        hours: hours2,
        minutes: minutes || 0,
        seconds
      } : {
        hours: hours2,
        minutes: minutes || 0
      }
    );
  };
  const rifm = useRifm({
    value: v,
    onChange: setV,
    format: includeSeconds ? formatTimeWithSeconds : formatTime,
    mask: true,
    replace: includeSeconds ? addMaskWithSeconds : addMask
  });
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("inline-flex", wrapperClass) }, /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: `flex flex-row flex-1 border border-gray-300 rounded-md ${props.disabled && "bg-gray-100"}`
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        className: "inset-y-0 left-0 px-1.5 my-1 ml-1 rounded-full flex items-center pointer-events-none",
        "aria-hidden": true
      },
      /* @__PURE__ */ React63.createElement(HiClock, { className: "w-4 h-4 text-gray-400" })
    ),
    /* @__PURE__ */ React63.createElement(
      TextInput,
      {
        value: rifm.value,
        ...props,
        onChange: callAll(rifm.onChange, props.onChange),
        onBlur: callAll((ev) => {
          const newValue = parseValue(ev.target.value, isPm, includeSeconds);
          if (newValue) {
            if (hours !== newValue.hours || minutes !== newValue.minutes || includeSeconds && seconds !== newValue.seconds) {
              onValue(newValue);
            }
          } else {
            if (isDefined(hours) || isDefined(minutes) || includeSeconds && isDefined(seconds)) {
              onValue(void 0);
            }
          }
        }, props.onBlur),
        className: clsx(
          `w-[180px]`,
          // includeSeconds ? 'w-[119px]' : 'w-[105px]',
          props.className
        ),
        noBorder: true
      }
    ),
    /* @__PURE__ */ React63.createElement("div", { className: "inset-y-0 right-1 flex flex-col items-center justify-center" }, /* @__PURE__ */ React63.createElement(
      MiniIconButton,
      {
        onClick: () => handleChangeHour((hours || 0) + 1),
        disabled: props.disabled || hours === 23,
        className: "pt-2 rounded-t-xl"
      },
      /* @__PURE__ */ React63.createElement("span", { className: "sr-only" }, "Increase hour"),
      /* @__PURE__ */ React63.createElement(HiOutlineChevronUp, { className: "text-lightgrey w-3 h-3" })
    ), /* @__PURE__ */ React63.createElement(
      MiniIconButton,
      {
        onClick: () => handleChangeHour((hours || 0) - 1),
        disabled: props.disabled || !hours,
        className: "pb-2 rounded-b-xl"
      },
      /* @__PURE__ */ React63.createElement("span", { className: "sr-only" }, "Decrease hour"),
      /* @__PURE__ */ React63.createElement(HiOutlineChevronUp, { className: "text-lightgrey w-3 h-3 transform rotate-180" })
    )),
    /* @__PURE__ */ React63.createElement(
      Select,
      {
        value: isPm ? "PM" : "AM",
        className: clsx(
          "w-[100px] rounded-l-none ring-0 border-l border-gray-300 z-0"
        ),
        onValue: (value) => handleChangeHour((hours || 0) + (value === "AM" ? -12 : 12)),
        disabled: props.disabled,
        options: amPmOptions,
        noBorder: true,
        size: props.size
      }
    )
  ));
};
var MiniIconButton = (props) => /* @__PURE__ */ React63.createElement(
  "button",
  {
    type: "button",
    tabIndex: -1,
    "aria-hidden": true,
    ...props,
    className: clsx(
      "flex-1 px-2 focus:outline-none",
      !props.disabled && "active:bg-gray-100",
      props.className
    )
  }
);
var amPmOptions = [
  {
    value: "AM",
    label: "AM"
  },
  {
    value: "PM",
    label: "PM"
  }
];
var parseTimeDigits = (value) => (value.match(/^(0[1-9]|1[0-2]):?([0-5][0-9]?)?:?([0-5][0-9]?)?/) || value.match(/^(0|1)/) || []).slice(1).join("");
var formatTime = (value) => {
  const digits = parseTimeDigits(value);
  const chars = digits.split("");
  return chars.reduce((r, v, index) => index === 2 ? `${r}:${v}` : `${r}${v}`, "").substring(0, 5);
};
var formatTimeWithSeconds = (value) => {
  const digits = parseTimeDigits(value);
  const chars = digits.split("");
  return chars.reduce(
    (r, v, index) => index === 2 || index === 4 ? `${r}:${v}` : `${r}${v}`,
    ""
  ).substring(0, 8);
};
var addMask = (value) => {
  const digits = parseTimeDigits(value);
  const hours = padEnd(digits.slice(0, 2), 2, "_");
  const minutes = padEnd(digits.slice(2, 4), 2, "_");
  return `${hours}:${minutes}`;
};
var addMaskWithSeconds = (value) => {
  const digits = parseTimeDigits(value);
  const hours = padEnd(digits.slice(0, 2), 2, "_");
  const minutes = padEnd(digits.slice(2, 4), 2, "_");
  const seconds = padEnd(digits.slice(4, 6), 2, "_");
  return `${hours}:${minutes}:${seconds}`;
};
var parseValue = (value, isPm, includeSeconds) => {
  const digits = parseTimeDigits(value);
  if (!digits) {
    return void 0;
  }
  const parsedHours = Number(padStart(digits.slice(0, 2), 2, "0"));
  const hours = parsedHours > 12 || parsedHours === 0 ? parsedHours : parsedHours === 12 ? isPm ? 12 : 0 : isPm ? 12 + parsedHours : parsedHours;
  const minutes = Number(padStart(digits.slice(2, 4), 2, "0"));
  const seconds = Number(padStart(digits.slice(4, 6), 2, "0"));
  return includeSeconds ? {
    hours,
    minutes,
    seconds
  } : {
    hours,
    minutes
  };
};

// src/components/date-time-input.tsx
var DateTimeInput = React63.forwardRef(
  function DateTimeInput2({ value, onValue, wrapperClass, dayClass, timeClass, includeSeconds, ...dayProps }, forwardedRef) {
    const currentHour = value ? value.getHours() : 0;
    const currentMinute = value ? value.getMinutes() : 0;
    return /* @__PURE__ */ React63.createElement("div", { className: clsx("flex flex-wrap gap-3", wrapperClass) }, /* @__PURE__ */ React63.createElement(
      DaySelector,
      {
        value,
        className: clsx(dayClass, "w-40"),
        onValue: (newDay) => {
          onValue(
            newDay && setDate(newDay, {
              hours: currentHour,
              minutes: currentMinute
            })
          );
        },
        ...dayProps,
        ref: forwardedRef
      }
    ), /* @__PURE__ */ React63.createElement(
      TimeInput,
      {
        hours: currentHour,
        minutes: currentMinute,
        seconds: includeSeconds ? value ? value.getSeconds() : 0 : void 0,
        disabled: dayProps.disabled || !value,
        onValue: (changes) => onValue(setDate(value, changes || { hours: 0, minutes: 0, seconds: 0 })),
        className: timeClass,
        includeSeconds
      }
    ));
  }
);

// src/components/date-time-field.tsx
var DateTimeField = React63.forwardRef(
  function DateTimeField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(DateTimeInput, { ...props, ref: forwardedRef }));
  }
);
var DayField = React63.forwardRef(function DayField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(DaySelector, { ...props, ref: forwardedRef }));
});
var Skeleton = ({
  width = "narrow",
  height = "short",
  bgClass = "bg-gray-200",
  heightClass = heightClasses[height],
  widthClass = widthClasses[width],
  className,
  ...props
}) => /* @__PURE__ */ React63.createElement("div", { ...props, className: clsx(bgClass, heightClass, widthClass, className) });
var widthClasses = {
  narrow: "w-12",
  medium: "w-32",
  wide: "w-48",
  full: "w-full"
};
var heightClasses = {
  short: "h-4",
  medium: "h-6",
  tall: "h-9"
};

// src/components/desc-list.tsx
var DescContext = createNamedContext(
  {
    isLoading: false,
    itemLayout: "vertical"
  },
  "DescContext"
);
var DescItem = ({ label, value, span, ...props }) => {
  const context = React63.useContext(DescContext);
  const isVertical = context.itemLayout === "vertical";
  return /* @__PURE__ */ React63.createElement(
    "div",
    {
      ...props,
      className: clsx(
        isVertical ? ["block", span === 2 && "@md/desc:col-span-2"] : "flex justify-between items-center py-1 hover:bg-gray-50",
        props.className
      )
    },
    /* @__PURE__ */ React63.createElement("dt", { className: "block text-gray-500 text-sm" }, label),
    /* @__PURE__ */ React63.createElement("dd", { className: clsx("block break-words text-black", isVertical && "text-sm") }, isNil(value) || value === "" ? context.isLoading ? /* @__PURE__ */ React63.createElement(Skeleton, { heightClass: "h-5", width: "medium" }) : "-" : value)
  );
};
var DescListImpl = function({
  isLoading = false,
  itemLayout = "vertical",
  className,
  ...props
}) {
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("@container/desc", className) }, /* @__PURE__ */ React63.createElement(
    DescContext.Provider,
    {
      value: React63.useMemo(() => ({ isLoading, itemLayout }), [isLoading, itemLayout])
    },
    /* @__PURE__ */ React63.createElement(
      "dl",
      {
        className: clsx(
          "grid",
          itemLayout === "vertical" ? "gap-5 @md/desc:grid-cols-2 @md/desc:gap-x-10" : "gap-3",
          isLoading && "animate-pulse"
        ),
        ...props
      }
    )
  ));
};
var DescList = Object.assign(DescListImpl, { Item: DescItem });
var IsInDialogContext = createNamedContext(false, "DialogContext");
var useIsInDialog = () => React63.useContext(IsInDialogContext);

// src/components/dialog.tsx
var DialogCloseButton = React63.forwardRef(function DialogCloseButton2(props, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(
    Primitive6.Close,
    {
      ...props,
      className: clsx(
        "absolute top-2 right-2 p-1 rounded-full text-gray-500 hover:text-gray-600",
        "focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
        props.className
      ),
      ref: forwardedRef
    },
    /* @__PURE__ */ React63.createElement(HiX, { width: 20, height: 20, className: "w-5 h-5" })
  );
});
var Dialog = Object.assign({}, Primitive6, {
  Content: React63.forwardRef(function StyledContent2(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(IsInDialogContext.Provider, { value: true }, /* @__PURE__ */ React63.createElement(
      Primitive6.Content,
      {
        ...props,
        ref: forwardedRef,
        className: clsx(
          "fixed bg-white px-4 py-2 rounded shadow top-20 max-h-[calc(100vh-6rem)] overflow-y-auto left-1/2 -translate-x-1/2",
          props.className
        )
      }
    ));
  }),
  Overlay: React63.forwardRef(function StyledOverlay2(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive6.Overlay,
      {
        ...props,
        ref: forwardedRef,
        className: clsx("fixed inset-0 bg-gray-500 opacity-70", props.className)
      }
    );
  }),
  Title: React63.forwardRef(function StyledTitle2(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive6.Title,
      {
        ...props,
        ref: forwardedRef,
        className: clsx(
          "text-lg font-medium pb-2 min-w-[80vw] sm:min-w-[30rem] border-b border-gray-200",
          props.className
        )
      }
    );
  }),
  CloseButton: DialogCloseButton,
  LeftContent: React63.forwardRef(function LeftContent(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive6.Content,
      {
        ...props,
        ref: forwardedRef,
        className: clsx(
          "fixed bg-white inset-y-0 left-0 animate-[slideinleft_100ms_ease-out]",
          props.className
        )
      }
    );
  })
});
var IconButton = React63.forwardRef(function IconButton2({ type = "button", paddingClass = "p-1", ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(
    "button",
    {
      ...props,
      type,
      className: clsx(
        "text-gray-500 rounded-full focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
        paddingClass,
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var ImageViewer = React63.forwardRef(function ImageViewer2({ file, wrapperClass, alt, src, children, imageRef, ...props }, ref) {
  const [previewUrl, setPreviewUrl] = React63.useState("");
  React63.useEffect(() => {
    if (file) {
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);
      return () => {
        URL.revokeObjectURL(preview);
      };
    }
  }, [file]);
  const imgSrc = src || file && previewUrl;
  return imgSrc ? /* @__PURE__ */ React63.createElement("div", { className: clsx("relative inline-block", wrapperClass), ref }, /* @__PURE__ */ React63.createElement("img", { ...props, src: imgSrc, alt: alt || imgSrc.split("/").pop(), ref: imageRef }), children) : null;
});
var Progress = ({ progress, style = {}, ...divProps }) => /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
  Primitive7.Root,
  {
    ...divProps,
    className: clsx(
      "relative h-1 shadow-inner rounded-lg overflow-hidden bg-gray-300",
      divProps.className
    ),
    value: progress * 100,
    max: 100,
    style: {
      /* Fix overflow clipping in Safari */
      /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
      transform: "translateZ(0)",
      ...style
    }
  },
  /* @__PURE__ */ React63.createElement(
    Primitive7.Indicator,
    {
      className: clsx(
        "w-full h-full bg-primary-500 transition-transform",
        progress > 0 && progress < 1 && "animate-pulse"
      ),
      style: { transform: `translateX(-${(1 - progress) * 100}%)` }
    }
  )
));

// src/components/file-item.tsx
var FileItem = ({
  file,
  uploadStatus,
  uploadProgress = 0.5,
  onRemove,
  onRetry,
  errorMessage = "Error",
  alt,
  onAltChange,
  className,
  imageViewerClassName
}) => {
  const isImage = file.type.indexOf("image") === 0;
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("w-80 mx-auto", className) }, /* @__PURE__ */ React63.createElement("div", { className: "text-center" }, isImage ? /* @__PURE__ */ React63.createElement(ImageViewer, { file, className: clsx("max-h-60", imageViewerClassName), alt }) : /* @__PURE__ */ React63.createElement("div", null, file.name)), /* @__PURE__ */ React63.createElement("div", { className: "flex justify-between" }, /* @__PURE__ */ React63.createElement("div", { className: "flex-shrink-0 flex items-center text-sm" }, uploadStatus === "completed" && /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    HiOutlineCheck,
    {
      className: "w-5 h-5 text-green-500 mr-2 inline-block",
      width: 20,
      height: 20
    }
  ), " ", !onAltChange && /* @__PURE__ */ React63.createElement("span", { className: "text-green-600" }, "Uploaded")), uploadStatus === "error" && /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    HiOutlineX,
    {
      className: "w-5 h-5 text-red-500 mr-2 inline-block",
      width: 20,
      height: 20
    }
  ), " ", /* @__PURE__ */ React63.createElement("span", { className: "text-red-600" }, errorMessage))), /* @__PURE__ */ React63.createElement("div", { className: "flex-1" }, uploadStatus === "uploading" && /* @__PURE__ */ React63.createElement(Progress, { progress: uploadProgress, className: "w-full" }), uploadStatus === "completed" && onAltChange && /* @__PURE__ */ React63.createElement(TextInput, { value: alt, onValue: onAltChange, size: "sm" })), /* @__PURE__ */ React63.createElement("div", { className: "flex-shrink-0" }, uploadStatus === "error" && /* @__PURE__ */ React63.createElement(IconButton, { onClick: onRetry, "aria-label": "Retry" }, /* @__PURE__ */ React63.createElement(HiOutlineRefresh, { width: 20, height: 20 })), /* @__PURE__ */ React63.createElement(IconButton, { onClick: onRemove, "aria-label": "Remove" }, /* @__PURE__ */ React63.createElement(HiOutlineTrash, { className: "w-5 h-5 text-red-500", width: 20, height: 20 })))));
};
var ImageItem = (props) => {
  const fileInfo = getFileInfo(props.url);
  const alt = props.alt || fileInfo.fileName;
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("w-80 mx-auto", props.className) }, /* @__PURE__ */ React63.createElement("div", { className: "text-center" }, /* @__PURE__ */ React63.createElement(
    ImageViewer,
    {
      src: props.url,
      className: clsx("max-h-60", props?.imageViewerClassName),
      alt
    }
  )), /* @__PURE__ */ React63.createElement("div", { className: "flex justify-between items-center" }, props.onAltChange ? /* @__PURE__ */ React63.createElement("div", { className: "flex-1" }, /* @__PURE__ */ React63.createElement(
    TextInput,
    {
      value: alt,
      onValue: props.onAltChange,
      disabled: props.disabled,
      size: "sm"
    }
  )) : /* @__PURE__ */ React63.createElement("span", { className: "text-sm" }, alt), /* @__PURE__ */ React63.createElement(
    IconButton,
    {
      onClick: props.onRemove,
      disabled: props.disabled || props.isRemoving,
      "aria-label": "Remove"
    },
    props.isRemoving ? /* @__PURE__ */ React63.createElement(Spinner, { className: "w-5 h-5 text-red-500 animate-spin", width: 20, height: 20 }) : /* @__PURE__ */ React63.createElement(HiOutlineTrash, { className: "w-5 h-5 text-red-500", width: 20, height: 20 })
  )));
};
var RemoteFileItem = (props) => {
  const fileInfo = getFileInfo(props.url);
  return fileInfo.isImage ? /* @__PURE__ */ React63.createElement(ImageItem, { ...props }) : /* @__PURE__ */ React63.createElement("div", { className: clsx("w-80 mx-auto", props.className) }, /* @__PURE__ */ React63.createElement("div", { className: "text-center" }, /* @__PURE__ */ React63.createElement("a", { href: props.url, target: "_BLANK", rel: "noreferrer" }, fileInfo.fileName)), /* @__PURE__ */ React63.createElement("div", { className: "text-right" }, /* @__PURE__ */ React63.createElement(
    IconButton,
    {
      onClick: props.onRemove,
      disabled: props.isRemoving || props.disabled,
      "aria-label": "Remove"
    },
    props.isRemoving ? /* @__PURE__ */ React63.createElement(Spinner, { className: "w-6 h-6 text-red-500 animate-spin" }) : /* @__PURE__ */ React63.createElement(HiOutlineTrash, { className: "w-6 h-6 text-red-500" })
  )));
};
var getFileInfo = (fileUrl) => {
  const fileName = fileUrl.split("/").pop();
  return {
    fileName,
    isImage: /\.(jpe?g|png)$/.test(fileName)
  };
};
var FileUpload = React63.forwardRef(function FileUpload2({
  onFilesSelected,
  variant = "area",
  fileType,
  accept = fileType === "image" ? "image/*" : void 0,
  label = "Upload",
  hint = "Drag or click to select a file.",
  className,
  Icon: Icon2 = HiOutlineUpload,
  ...inputProps
}, forwardedRef) {
  const [isDragOver, setIsDragOver] = React63.useState(false);
  const generatedId = React63.useId();
  const inputId = inputProps.id || generatedId;
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("relative p-1", className) }, /* @__PURE__ */ React63.createElement(
    "input",
    {
      type: "file",
      value: "",
      accept,
      ...inputProps,
      id: inputId,
      onChange: (ev) => {
        if (ev.target.files) {
          onFilesSelected(Array.from(ev.target.files));
        }
      },
      className: "sr-only peer",
      ref: forwardedRef
    }
  ), variant === "area" ? /* @__PURE__ */ React63.createElement(
    "label",
    {
      htmlFor: inputId,
      onDragEnter: (ev) => {
        ev.preventDefault();
        setIsDragOver(true);
      },
      onDragLeave: (ev) => {
        ev.preventDefault();
        setIsDragOver(false);
      },
      onDragOver: (ev) => ev.preventDefault(),
      onDrop: (ev) => {
        ev.preventDefault();
        if (ev.dataTransfer.files) {
          onFilesSelected(Array.from(ev.dataTransfer.files));
        }
        setIsDragOver(false);
      },
      className: clsx(
        "flex justify-center items-center p-4 sm:p-6 rounded-lg border-2 border-dashed",
        inputProps.disabled ? "cursor-not-allowed bg-gray-50 opacity-60" : "cursor-pointer hover:bg-gray-50",
        isDragOver ? "border-primary-500 bg-primary-500 bg-opacity-5" : "border-gray-300",
        "peer-focus-visible:ring peer-focus-visible:ring-primary-200"
      )
    },
    /* @__PURE__ */ React63.createElement("div", { className: "text-gray-400 text-center pointer-events-auto" }, /* @__PURE__ */ React63.createElement(Icon2, { className: "inline-block w-8 h-8 text-gray-400 mb-2" }), /* @__PURE__ */ React63.createElement("div", null, label), /* @__PURE__ */ React63.createElement("div", { className: "text-xs mt-1" }, hint))
  ) : /* @__PURE__ */ React63.createElement(
    Button,
    {
      icon: /* @__PURE__ */ React63.createElement(Icon2, { className: "w-5 h-5" }),
      render: (btnProps) => /* @__PURE__ */ React63.createElement("label", { ...btnProps, htmlFor: inputId, "aria-label": label }),
      shape: "circle",
      variant: "twoTone",
      className: "cursor-pointer disabled:cursor-not-allowed peer-focus-visible:ring peer-focus-visible:ring-primary-200",
      disabled: inputProps.disabled
    }
  ));
});
var Option = React63.forwardRef(function Option2({ highlighted, selected, label, description, leftIcon, render, ...divProps }, forwardedRef) {
  const isDisabled = divProps.disabled || divProps["aria-disabled"] && divProps["aria-disabled"] !== "false";
  const className = clsx(
    "flex items-center px-4 cursor-pointer select-none focus:outline-none",
    highlighted ? "bg-gray-50" : selected && "bg-gray-100",
    divProps.className
  );
  const children = /* @__PURE__ */ React63.createElement(React63.Fragment, null, leftIcon, /* @__PURE__ */ React63.createElement("div", { className: clsx("py-2 flex-1 overflow-hidden", !!leftIcon && "pl-3") }, /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: clsx(
        "sm:text-sm leading-snug truncate",
        isDisabled ? "text-gray-500" : "text-black"
      )
    },
    label
  ), description && /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: clsx(
        "text-xs font-normal leading-snug truncate",
        isDisabled ? "text-gray-400" : "text-gray-500"
      )
    },
    description
  )), selected && /* @__PURE__ */ React63.createElement(HiCheck, { className: "text-primary-600" }));
  if (render) {
    return render({
      children,
      className
    });
  }
  return /* @__PURE__ */ React63.createElement("div", { ...divProps, className, ref: forwardedRef }, children);
});
var OptGroupLabel = (props) => /* @__PURE__ */ React63.createElement(
  "div",
  {
    ...props,
    className: clsx(
      "px-4 py-3 mt-4 first:mt-0 text-xs font-bold tracking-1 text-lightgrey uppercase select-none",
      props.className
    )
  }
);
var normalizeOptions = (options) => {
  const result = [];
  options.forEach((option) => {
    if (isGroupOption(option)) {
      result.push(option);
    } else {
      if (result.length === 0 || result[result.length - 1].label !== "") {
        result.push({
          label: "",
          options: [option]
        });
      } else {
        result[result.length - 1].options.push(option);
      }
    }
  });
  return result;
};
var SELECT_ALL = "__ScalingWorks_SELECT_ALL__";
var sortOptions = (options, searchValue, {
  allowSelectAll,
  additionalFilter
} = {}) => {
  if (options.length === 0) {
    return {
      items: [],
      displayedItems: [],
      allItems: []
    };
  }
  return mapGroup(normalizeOptions(options), {
    allowSelectAll,
    filter: (options2) => {
      const result = matchSorter(options2, searchValue, {
        keys: ["label", "description"]
      });
      return additionalFilter ? result.filter(additionalFilter) : result;
    }
  });
};
var flattenOptions = (optionsOrGroups) => {
  const result = [];
  optionsOrGroups.forEach(function collect(optionOrGroup) {
    if (isGroupOption(optionOrGroup)) {
      optionOrGroup.options.forEach(collect);
    } else {
      result.push(optionOrGroup);
    }
  });
  return result;
};
var selectAllOption = {
  value: SELECT_ALL,
  label: "",
  index: 0
};
var mapGroup = (groups, {
  filter = (x) => x,
  allowSelectAll
} = {}) => {
  const groupsWithSortedOptions = groups.filter((group) => group.options.length !== 0);
  let optionIndex = allowSelectAll ? 1 : 0;
  const mappedPrependOption = allowSelectAll ? selectAllOption : void 0;
  const result = mappedPrependOption ? {
    items: [mappedPrependOption],
    displayedItems: [
      {
        options: [mappedPrependOption]
      }
    ],
    allItems: [mappedPrependOption]
  } : {
    items: [],
    displayedItems: [],
    allItems: []
  };
  groupsWithSortedOptions.forEach((group) => {
    const finalOptions = [];
    const filteredOptions = filter(group.options);
    group.options.forEach((option) => {
      if (filteredOptions.includes(option)) {
        const mappedOption = {
          ...option,
          index: optionIndex++
        };
        finalOptions.push(mappedOption);
        result.items.push(mappedOption);
        result.allItems.push(mappedOption);
      } else {
        result.allItems.push(option);
      }
    });
    if (finalOptions.length > 0) {
      result.displayedItems.push({
        groupLabel: group.label,
        options: finalOptions
      });
    }
  });
  if (allowSelectAll) {
    const totalOptionCount = result.displayedItems.reduce(
      (total, group) => total + group.options.length,
      0
    );
    if (totalOptionCount <= 2) {
      result.items.splice(0, 1);
      result.displayedItems.splice(0, 1);
      result.allItems.splice(0, 1);
      result.items.forEach((item) => {
        item.index--;
      });
    }
  }
  return result;
};
var isGroupOption = (option) => option.type === "group";
var Menu = Object.assign({}, MenuPrimitive, {
  Item: React63.forwardRef(function StyledMenuItem(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      MenuPrimitive.Item,
      {
        ...props,
        className: clsx(itemClass, props.className),
        ref: forwardedRef
      }
    );
  }),
  Content: React63.forwardRef(
    function StyledMenuContent({ children, style, ...props }, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        MenuPrimitive.Content,
        {
          ...props,
          style: style ? {
            ...contentStyle,
            ...style
          } : contentStyle,
          className: contentClass,
          ref: forwardedRef
        },
        /* @__PURE__ */ React63.createElement("div", { className: clsx(innerContentClass, props.className) }, children)
      );
    }
  ),
  SubTrigger: React63.forwardRef(
    function StyledSubTrigger(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        MenuPrimitive.SubTrigger,
        {
          ...props,
          className: clsx(itemClass, props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  SubContent: React63.forwardRef(
    function StyledMenuSubContent(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        MenuPrimitive.SubContent,
        {
          ...props,
          style: contentStyle,
          className: clsx(contentClass, innerContentClass, props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  RadioItem: React63.forwardRef(
    function StyledMenuRadioItem(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        MenuPrimitive.RadioItem,
        {
          ...props,
          className: clsx(itemClass, props.className),
          ref: forwardedRef
        }
      );
    }
  )
});
var itemClass = "px-3 py-2 text-sm focus:outline-none data-[highlighted]:text-gray-900 data-[highlighted]:bg-gray-200";
var contentClass = "min-w-[10rem] bg-white shadow-lg rounded-md animate-[scalein_100ms_ease-out]";
var innerContentClass = "flex flex-col gap-1 p-1 shadow rounded-md";
var contentStyle = {
  transformOrigin: "var(--radix-dropdown-menu-content-transform-origin)"
};
var MultiSelectImpl = forwardRefWithGenerics(function MultiSelect({
  value,
  onValue,
  options,
  allowToggleAll,
  selectAllLabel = "Select all",
  unselectAllLabel = "Unselect all",
  size: size$1,
  placeholder,
  onFocus,
  className,
  name,
  required,
  ...buttonProps
}, forwardedRef) {
  const { inputId } = useFormControl();
  const selectSize = useFormControlSize(size$1);
  const optionData = React63.useMemo(() => {
    return options && sortOptions(options, "", {
      allowSelectAll: allowToggleAll
    });
  }, [options, allowToggleAll, value]);
  const selectedItems = React63.useMemo(
    () => optionData ? value.map((v) => optionData.allItems.find((opt) => opt.value === v)).filter(isDefined) : [],
    [value, optionData]
  );
  const isAllSelected = React63.useMemo(
    () => optionData && value.length === optionData.allItems.filter((opt) => opt.value !== SELECT_ALL).length,
    [optionData, value]
  );
  const { isOpen, getItemProps, getMenuProps, highlightedIndex, getToggleButtonProps } = useSelect({
    selectedItem: null,
    itemToString: (i) => i ? i.label : "",
    items: optionData ? optionData.items : [],
    stateReducer: (state, { type, changes }) => {
      if (type === useSelect.stateChangeTypes.ItemClick || type === useSelect.stateChangeTypes.ToggleButtonKeyDownEnter) {
        return {
          ...changes,
          isOpen: state.isOpen,
          highlightedIndex: state.highlightedIndex
        };
      }
      return changes;
    },
    onStateChange: ({ type, selectedItem }) => {
      switch (type) {
        case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect.stateChangeTypes.ItemClick:
          if (selectedItem) {
            if (selectedItem.value === SELECT_ALL) {
              if (isAllSelected) {
                onValue([]);
              } else {
                if (optionData) {
                  const result = selectedItems.slice();
                  optionData.items.forEach((item) => {
                    if (item.value !== SELECT_ALL && !result.includes(item)) {
                      result.push(item);
                    }
                  });
                  onValue(result.map((r) => r.value));
                }
              }
            } else {
              const currentIndex = value.findIndex((v) => selectedItem.value === v);
              if (currentIndex >= 0) {
                onValue(value.filter((_, index) => index !== currentIndex));
              } else {
                onValue(value.concat(selectedItem.value));
              }
            }
          }
          break;
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: [
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  const btnRef = React63.useRef(null);
  const refToApply = useComposedRefs(btnRef, forwardedRef);
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement("div", { className: clsx("w-full", className), ref: floatingHelpers.refs.setReference }, /* @__PURE__ */ React63.createElement(
    "button",
    {
      ...getToggleButtonProps({
        id: inputId,
        type: "button",
        ...buttonProps,
        className: clsx(
          "flex justify-between items-center w-full rounded-md",
          "border border-gray-300",
          "focus:outline-none focus-visible:border-primary-600 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-opacity-50",
          selectSize === "lg" && "text-lg",
          heightBySize[selectSize],
          buttonProps.disabled ? "bg-gray-100 dark:bg-gray-700  text-gray-400 cursor-not-allowed placeholder:opacity-70" : "bg-white"
        ),
        ref: refToApply
      })
    },
    /* @__PURE__ */ React63.createElement(
      "span",
      {
        className: clsx(
          "block px-3 py-2 truncate",
          !selectedItems.length && "text-gray-400"
        )
      },
      selectedItems.length ? selectedItems.map((item) => item.label).join(", ") : placeholder
    ),
    /* @__PURE__ */ React63.createElement("span", { className: "p-2 text-xl" }, /* @__PURE__ */ React63.createElement(HiChevronDown, { className: "text-gray-400", width: 20, height: 20 }))
  )), (required || name) && /* @__PURE__ */ React63.createElement(
    "input",
    {
      type: "hidden",
      name,
      required,
      value: selectedItems.map((i) => i.label).join(",")
    }
  ), /* @__PURE__ */ React63.createElement(Root, null, /* @__PURE__ */ React63.createElement(
    "div",
    {
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg"
          )
        })
      },
      isOpen && (optionData ? optionData.displayedItems.length === 0 ? /* @__PURE__ */ React63.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React63.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React63.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React63.createElement("div", null, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React63.createElement(React63.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React63.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => {
          if (option.value === SELECT_ALL) {
            return /* @__PURE__ */ React63.createElement(
              Option,
              {
                key: `${option.value}-${option.index}`,
                ...getItemProps({
                  item: option,
                  index: option.index,
                  disabled: option.disabled || buttonProps.disabled
                }),
                highlighted: option.index === highlightedIndex,
                label: isAllSelected ? unselectAllLabel : selectAllLabel,
                className: "border-b border-gray-200"
              }
            );
          }
          return /* @__PURE__ */ React63.createElement(
            Option,
            {
              key: `${option.value}-${option.index}`,
              ...getItemProps({
                item: option,
                index: option.index,
                disabled: option.disabled || buttonProps.disabled
              }),
              leftIcon: option.icon,
              label: option.label,
              description: option.description,
              highlighted: option.index === highlightedIndex,
              selected: value.includes(option.value)
            }
          );
        })))))
      ) : /* @__PURE__ */ React63.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React63.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var MultiSelect2 = forwardRefWithGenerics(function MultiSelectOuter(props, forwardedRef) {
  const isInDialog = useIsInDialog();
  const [mounted, setMounted] = React63.useState(false);
  React63.useEffect(() => {
    setMounted(true);
  }, []);
  return isInDialog && !mounted ? /* @__PURE__ */ React63.createElement(
    TextInput,
    {
      className: props.className,
      size: props.size,
      id: props.id,
      placeholder: props.placeholder,
      disabled: true
    }
  ) : /* @__PURE__ */ React63.createElement(MultiSelectImpl, { ...props, ref: forwardedRef });
});
var MultiSelectField = forwardRefWithGenerics(function MultiSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(MultiSelect2, { ...props, ref: forwardedRef }));
});
var MultiInputImpl = React63.forwardRef(
  function MultiInputImpl2({ size, ...props }, forwardedRef) {
    if (props?.type === "textarea")
      return /* @__PURE__ */ React63.createElement(
        "textarea",
        {
          ...props,
          className: clsx(
            "flex-1 min-w-[2.5rem]",
            size === "lg" && "text-lg",
            props.disabled && "placeholder:opacity-70",
            "focus:outline-none",
            props.className
          ),
          ref: forwardedRef
        }
      );
    return /* @__PURE__ */ React63.createElement(
      "input",
      {
        ...props,
        className: clsx(
          "flex-1 min-w-[2.5rem]",
          size === "lg" && "text-lg",
          props.disabled && "placeholder:opacity-70",
          "focus:outline-none",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var MultiInputImplWrapper = React63.forwardRef(
  function MultiInputImplWrapper2({ noBorder, disabled, size, noWrap, type, ...props }, ref) {
    return /* @__PURE__ */ React63.createElement(
      "div",
      {
        ...props,
        className: clsx(
          "w-full flex items-start gap-x-1 gap-y-2 overflow-x-auto px-3 rounded-md",
          !noWrap && "flex-wrap",
          { xs: "py-0", sm: "py-1", md: "py-2", lg: "py-2" }[size],
          !noBorder && "border border-gray-300",
          type !== "textarea" && heightBySize[size],
          disabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "cursor-text",
          "focus-within:border-primary-600 focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-opacity-50",
          props.className
        ),
        ref
      }
    );
  }
);
var MultiInputBadge = React63.forwardRef(
  function MultiInputBadge2({ onDismiss, size, children, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      "span",
      {
        ...props,
        className: clsx(
          "inline-flex items-center gap-1 px-2 rounded-full select-none",
          "bg-gray-100 text-gray-800",
          size === "lg" && "text-lg py-0.5",
          props.className
        ),
        ref: forwardedRef
      },
      children,
      /* @__PURE__ */ React63.createElement(
        "button",
        {
          type: "button",
          onClick: onDismiss,
          className: "flex-shrink-0 text-gray-600",
          tabIndex: -1,
          disabled: props.disabled
        },
        /* @__PURE__ */ React63.createElement(HiX, { className: "w-3 h-3" })
      )
    );
  }
);

// src/components/multi-text-input.tsx
var MultiTextInput = React63.forwardRef(
  function MultiTextInput2({
    value: providedValue,
    onValue,
    includeDraft,
    size,
    placeholder,
    className,
    name,
    required,
    ...inputProps
  }, forwardedRef) {
    const inputRef = React63.useRef(null);
    const refToApply = useComposedRefs(inputRef, forwardedRef);
    const { inputId } = useFormControl();
    const inputSize = useFormControlSize(size);
    const [inputValue, setInputValue] = React63.useState("");
    const values = React63.useMemo(() => {
      const valuesCount = /* @__PURE__ */ new Map();
      const values2 = [];
      providedValue.forEach((value, index) => {
        if (includeDraft && index === providedValue.length - 1 && value === inputValue.trim()) {
          return;
        }
        const currentCount = valuesCount.get(value) || 0;
        values2.push({
          value,
          key: `${value}-${currentCount}`
        });
        valuesCount.set(value, currentCount + 1);
      });
      return values2;
    }, [providedValue, includeDraft, inputValue]);
    const { selectedItems, getSelectedItemProps, getDropdownProps, addSelectedItem } = useMultipleSelection({
      selectedItems: values,
      onSelectedItemsChange: ({ selectedItems: selectedItems2 }) => {
        if (selectedItems2) {
          onValue(selectedItems2.map((v) => v.value));
        }
      }
    });
    const removeSelectedItem = (itemIndex) => {
      const result = selectedItems.filter((_, index) => index !== itemIndex).map((v) => v.value);
      onValue(result);
    };
    const addItem = (value) => {
      const val = value.trim();
      if (val) {
        const similarValues = selectedItems.filter((item) => item.value === val);
        addSelectedItem({
          value: val,
          key: `${val}-${similarValues.length}`
        });
        setInputValue("");
      }
    };
    const handleInputChange = (ev) => {
      const value = ev.target.value;
      if (!/^,+$/.test(value) && value[value.length - 1] === ",") {
        addItem(value.slice(0, -1));
      } else {
        setInputValue(value);
        if (includeDraft) {
          const trimmedInput = value.trim();
          const currentValues = selectedItems.map((i) => i.value);
          const result = trimmedInput ? currentValues.concat(trimmedInput) : currentValues;
          onValue(result);
        }
      }
    };
    const handleKeyDown = (ev) => {
      if ((ev.key === "Tab" || ev.key === "Enter") && inputValue) {
        ev.preventDefault();
        addItem(inputValue);
      }
    };
    return /* @__PURE__ */ React63.createElement(
      MultiInputImplWrapper,
      {
        onClick: (ev) => {
          if (!inputProps.disabled && ev.target === ev.currentTarget && inputRef.current) {
            inputRef.current.focus();
          }
        },
        disabled: inputProps.disabled,
        className,
        size: inputSize,
        type: inputProps?.type
      },
      selectedItems.map((item, index) => /* @__PURE__ */ React63.createElement(
        MultiInputBadge,
        {
          key: item.key,
          onDismiss: () => removeSelectedItem(index),
          ...getSelectedItemProps({
            selectedItem: item,
            index,
            ...inputProps.disabled ? { disabled: true, tabIndex: void 0 } : {}
          }),
          size: inputSize
        },
        item.value
      )),
      /* @__PURE__ */ React63.createElement(
        MultiInputImpl,
        {
          ...getDropdownProps({
            id: inputId,
            value: inputValue,
            onChange: handleInputChange,
            onKeyDown: handleKeyDown,
            placeholder: selectedItems.length ? void 0 : placeholder,
            ...inputProps,
            ref: refToApply
          }),
          size: inputSize
        }
      ),
      (name || required) && /* @__PURE__ */ React63.createElement(
        "input",
        {
          type: "hidden",
          name,
          value: selectedItems.map((it) => it.value).join(","),
          required
        }
      )
    );
  }
);

// src/components/multi-text-field.tsx
var MultiTextField = React63.forwardRef(
  function MultiTextField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(MultiTextInput, { ...props, ref: forwardedRef }));
  }
);

// src/utils/format-number.ts
var currencyMap = /* @__PURE__ */ new Map([["MYR", "RM"]]);
var commaPositionRegex = /\B(?=(\d{3})+(?!\d))/g;
var getDisplayedCurrency = (currency) => currencyMap.get(currency) || currency;
function insertThousandSeparator(number) {
  const numString = String(number);
  if (numString.includes(".")) {
    const [integer, decimal] = numString.split(".");
    return `${integer.replace(commaPositionRegex, ",")}.${decimal}`;
  }
  return numString.replace(commaPositionRegex, ",");
}
var numberFormatters = {};
var formatNumber = (value, { minDecimal = 2, maxDecimal = 2, currency, useFormatNumber } = {}) => {
  if (isNil(value)) {
    return "";
  }
  const numValue = typeof value === "number" ? value : Number(value);
  let displayValue = "";
  if (isNaN(numValue)) {
    return value;
  }
  if (featureCheck.intlNumberFormat) {
    const cacheKey = `${minDecimal}-${maxDecimal}`;
    if (!numberFormatters[cacheKey]) {
      numberFormatters[cacheKey] = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: minDecimal,
        maximumFractionDigits: maxDecimal,
        currency
      });
    }
    displayValue = useFormatNumber ? numberFormatters[cacheKey].format(numValue) : numValue?.toString();
  } else {
    const currencyDisplay = currency && getDisplayedCurrency(currency);
    const displayedNumber = useFormatNumber ? insertThousandSeparator(numValue.toFixed(maxDecimal)) : numValue.toFixed(maxDecimal);
    displayValue = currencyDisplay ? `${currencyDisplay} ${displayedNumber}` : displayedNumber;
  }
  return displayValue;
};

// src/components/number-input.tsx
var NumberInputImpl = React63.forwardRef(function NumberInput({
  decimalPlaces = 2,
  onValue: onChangeValue,
  allowTrailingZero,
  allowNegative,
  max,
  useFormatNumber = true,
  ...inputProps
}, forwardedRef) {
  const { value, onChange } = useRifm({
    value: inputProps.value,
    onChange: (newVal) => {
      onChangeValue && onChangeValue(parseNumber(newVal, decimalPlaces === 0, max, allowNegative));
    },
    accept: /[\d.-]/g,
    format: (val) => formatFixedPointNumber(
      val,
      decimalPlaces,
      max,
      allowTrailingZero,
      allowNegative,
      useFormatNumber
    )
  });
  return /* @__PURE__ */ React63.createElement(
    TextInput,
    {
      inputMode: decimalPlaces ? "decimal" : "numeric",
      ...inputProps,
      value,
      onChange: callAll(onChange, inputProps.onChange),
      ref: forwardedRef
    }
  );
});
var getNumberValue = (value) => {
  if (isNumber(value)) {
    return value;
  }
  if (value === "" || value === "-") {
    return void 0;
  }
  const numValue = Number(value);
  return isNaN(numValue) ? void 0 : numValue;
};
var NumberInput2 = Object.assign(NumberInputImpl, {
  getNumberValue
});
var numberAccept = /[\d.]+/g;
var negativeNumberAccept = /[\d.-]+/g;
var integerAccept = /[\d]+/g;
var negativeIntegerAccept = /[\d-]]+/g;
var MAX_SAFE_LENGTH = 16;
var parseNumber = (stringValue, isInteger, max, allowNegative) => {
  const string = String(stringValue);
  const result = (string.match(
    allowNegative ? isInteger ? negativeIntegerAccept : negativeNumberAccept : isInteger ? integerAccept : numberAccept
  ) || []).join("").substring(0, MAX_SAFE_LENGTH);
  if (isDefined(max) && Number(result) > max) {
    let finalResult = "";
    for (let index = 0; index < result.length; index++) {
      const char = result.charAt(index);
      const newResult = `${finalResult}${char}`;
      if (Number(newResult) > max) {
        return finalResult;
      }
      finalResult = newResult;
    }
    return finalResult;
  }
  return result;
};
var formatFixedPointNumber = (value, decimalPlaces, max, allowTrailingZero, allowNegative, useFormatNumber) => {
  const parsed = parseNumber(value, decimalPlaces === 0, max, allowNegative);
  if (parsed === "-") {
    return "-";
  }
  const [head, tail] = parsed.split(".");
  const scaledTail = tail != null ? tail.slice(0, decimalPlaces) : "";
  const number = Number.parseFloat(`${head}.${scaledTail}`);
  if (Number.isNaN(number)) {
    return "";
  }
  const formatted = formatNumber(number, {
    maxDecimal: scaledTail.length,
    minDecimal: scaledTail.length,
    useFormatNumber
  });
  if (parsed.includes(".")) {
    const [formattedHead] = formatted.split(".");
    const formattedTail = scaledTail !== "" && scaledTail[decimalPlaces - 1] === "0" && !allowTrailingZero ? scaledTail.slice(0, -1) : scaledTail;
    return `${formattedHead}.${formattedTail}`;
  }
  return formatted;
};

// src/components/number-field.tsx
var NumberFieldImpl = React63.forwardRef(function NumberField({ id, status, label, useFormatNumber = true, renderError, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ React63.createElement(NumberInput2, { ...props, ref: forwardedRef, useFormatNumber }), renderError));
});
var NumberField2 = Object.assign(NumberFieldImpl, {
  getNumberValue: NumberInput2.getNumberValue
});
var Pagination = ({
  totalPages,
  currentPage,
  onChangePage,
  perPage,
  onChangePerPage,
  className,
  formatOption = defaultFormatOption,
  previousPageAriaLabel = "Previous page",
  nextPageAriaLabel = "Next page",
  ...props
}) => {
  const pageOptions = React63.useMemo(
    () => getPageOptions(currentPage, totalPages),
    [totalPages, currentPage]
  );
  const pageSizeOptions = React63.useMemo(() => getPageSizeOptions(perPage, formatOption), [perPage]);
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("flex justify-between items-center", className), ...props }, /* @__PURE__ */ React63.createElement("div", { className: "flex items-center" }, /* @__PURE__ */ React63.createElement(
    PaginationButton,
    {
      onClick: () => onChangePage(currentPage - 1),
      "aria-label": previousPageAriaLabel,
      disabled: currentPage === 1
    },
    /* @__PURE__ */ React63.createElement(HiChevronLeft, { "aria-hidden": true, width: 20, height: 20, className: "w-5 h-5" })
  ), pageOptions.map((page) => /* @__PURE__ */ React63.createElement(
    PaginationButton,
    {
      onClick: () => onChangePage(page),
      current: page === currentPage,
      key: page
    },
    page
  )), /* @__PURE__ */ React63.createElement(
    PaginationButton,
    {
      onClick: () => onChangePage(currentPage + 1),
      "aria-label": nextPageAriaLabel,
      disabled: currentPage >= totalPages
    },
    /* @__PURE__ */ React63.createElement(HiChevronRight, { "aria-hidden": true, width: 20, height: 20, className: "w-5 h-5" })
  )), /* @__PURE__ */ React63.createElement("div", { className: "w-48 px-3" }, /* @__PURE__ */ React63.createElement(
    Select,
    {
      value: String(perPage),
      onValue: (newPerPage) => {
        onChangePerPage(Number(newPerPage));
        onChangePage(1);
      },
      size: "sm",
      options: pageSizeOptions
    }
  )));
};
var defaultPageSizeOptions = [10, 20, 50, 100];
var defaultFormatOption = (pageSize) => `${pageSize} / page`;
var getPageSizeOptions = (currentPageSize, formatOption) => {
  const options = function getOptions() {
    if (defaultPageSizeOptions.includes(currentPageSize)) {
      return defaultPageSizeOptions;
    }
    return defaultPageSizeOptions.concat(currentPageSize).sort((a, b) => a - b);
  }();
  return options.map((size) => ({
    label: formatOption(size),
    value: String(size)
  }));
};
var PaginationButton = ({
  current,
  ...props
}) => /* @__PURE__ */ React63.createElement(
  "button",
  {
    type: "button",
    className: clsx(
      "relative mx-1 rounded inline-flex items-center h-8 w-8 justify-center text-sm font-semibold select-none transition-colors",
      current && "text-primary-600 bg-primary-50",
      !props.disabled && (current ? "hover:bg-primary-100" : "hover:bg-gray-100"),
      props.disabled ? "text-gray-500 opacity-50" : "text-gray-900"
    ),
    "aria-current": current,
    ...props
  }
);
var getPageOptions = (current, max) => {
  if (max <= MAX_OPTIONS_COUNT) {
    return createArray(max).map(mapOption);
  }
  if (current <= MAX_OPTIONS_COUNT - half) {
    return createArray(MAX_OPTIONS_COUNT).map(mapOption);
  }
  if (max - current <= half) {
    return createArray(MAX_OPTIONS_COUNT).map((_, index) => max - index).reverse();
  }
  return createArray(MAX_OPTIONS_COUNT).map((_, index) => current + index - half);
};
var MAX_OPTIONS_COUNT = 5;
var mapOption = (_, index) => index + 1;
var half = Math.floor(MAX_OPTIONS_COUNT / 2);
var createArray = (length) => Array.from({ length });
var PasswordInput = React63.forwardRef(
  function PasswordInput2(props, forwardedRef) {
    const [showPassword, toggleShowPassword] = React63.useReducer((x) => !x, false);
    return /* @__PURE__ */ React63.createElement(
      TextInput,
      {
        ...props,
        type: showPassword ? "text" : "password",
        ref: forwardedRef,
        suffix: /* @__PURE__ */ React63.createElement(
          "button",
          {
            onClick: toggleShowPassword,
            type: "button",
            className: "p-2 text-gray-600 rounded-full hover:bg-gray-100"
          },
          showPassword ? /* @__PURE__ */ React63.createElement(HiOutlineEye, null) : /* @__PURE__ */ React63.createElement(HiOutlineEyeOff, null)
        )
      }
    );
  }
);

// src/components/password-field.tsx
var PasswordField = React63.forwardRef(
  function PasswordField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(PasswordInput, { ...props, ref: forwardedRef }));
  }
);
var TextHighlight = (props) => /* @__PURE__ */ React63.createElement(Highlighter, { highlightClassName: "bg-primary-200", autoEscape: true, ...props });

// src/components/searchable-select.tsx
var SearchableSelectImpl = forwardRefWithGenerics(function SearchableSelect({
  value,
  onValue,
  options,
  wrapperClass,
  id,
  onFocus,
  onInputValueChange,
  initialLabel = isString(value) ? value : String(value),
  menuClass,
  size: size$1,
  prefix,
  suffix,
  menuAlignStart,
  allowFreeText,
  floatingPlacement = "bottom-start",
  ...inputProps
}, forwardedRef) {
  const { inputId: fieldId } = useFormControl();
  const inputId = id || fieldId;
  const [inputValue, setInputValue] = React63.useState(() => String(value));
  const trimmedInput = inputValue.trim();
  const [cachedItem, setCachedItem] = React63.useState(void 0);
  const validCachedItem = cachedItem && (cachedItem.value === value ? cachedItem : void 0);
  const optionData = React63.useMemo(() => {
    const removedOption = function findRemovedOption() {
      if (!validCachedItem) {
        return void 0;
      }
      if (!options) {
        return validCachedItem;
      }
      for (let index = 0; index < options.length; index++) {
        const option = options[index];
        if (option.type === "group") {
          for (let oIndex = 0; oIndex < option.options.length; oIndex++) {
            const childOption = option.options[oIndex];
            if (childOption.value === validCachedItem.value) {
              return void 0;
            }
          }
        } else {
          if (option.value === validCachedItem.value) {
            return void 0;
          }
        }
      }
      return validCachedItem;
    }();
    if (!options) {
      return removedOption ? sortOptions([removedOption], trimmedInput) : void 0;
    }
    return sortOptions(removedOption ? options.concat(removedOption) : options, trimmedInput);
  }, [options, trimmedInput, validCachedItem]);
  const selectedItem = React63.useMemo(() => {
    if (!value || !optionData) {
      return null;
    }
    return optionData.allItems.find((o) => o.value === value) || null;
  }, [value, optionData]);
  const displayedValue = React63.useMemo(() => {
    const fallbackValue = allowFreeText ? value : "";
    if (!optionData) {
      return fallbackValue;
    }
    const selectedOption = optionData.allItems.find((item) => item.value === value);
    return selectedOption ? selectedOption.label : fallbackValue;
  }, [optionData, value, allowFreeText]);
  React63.useEffect(() => {
    setInputValue(displayedValue);
  }, [displayedValue]);
  const {
    isOpen,
    openMenu,
    closeMenu,
    highlightedIndex,
    getInputProps,
    getItemProps,
    getToggleButtonProps,
    getMenuProps,
    selectItem
  } = useCombobox({
    inputValue,
    selectedItem,
    items: optionData && optionData.items || [],
    itemToString: (i) => i ? i.label : "",
    inputId,
    onSelectedItemChange: (changes) => {
      const selectedItem2 = changes.selectedItem;
      if (selectedItem2) {
        onValue(selectedItem2.value, selectedItem2.label);
        setCachedItem(selectedItem2);
      } else {
        onValue("", "");
      }
    },
    onStateChange: (change) => {
      if (allowFreeText) {
        if (change.type === useCombobox.stateChangeTypes.InputBlur) {
          if (inputValue !== displayedValue && inputValue !== value) {
            onValue(inputValue, inputValue);
          }
        }
        if (change.type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
          if (change.inputValue === "") {
            setInputValue("");
            onInputValueChange && onInputValueChange("");
            if (allowFreeText) {
              onValue("", "");
            }
          } else {
            if (inputValue !== displayedValue && inputValue !== value) {
              onValue(inputValue, inputValue);
            }
          }
        }
      } else {
        if (change.type === useCombobox.stateChangeTypes.InputBlur || change.type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
          if (inputValue !== displayedValue) {
            setInputValue(displayedValue);
          }
        }
        if (change.type === useCombobox.stateChangeTypes.InputKeyDownEscape && change.inputValue === "") {
          setInputValue("");
          onInputValueChange && onInputValueChange("");
        }
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: floatingPlacement,
    middleware: menuAlignStart ? [] : [
      size({
        apply({ rects, elements }) {
          if (rects.reference.width > rects.floating.width) {
            Object.assign(elements.floating.style, {
              width: `${rects.reference.width}px`
            });
          }
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement("div", { className: clsx("relative", wrapperClass), ref: floatingHelpers.refs.setReference }, /* @__PURE__ */ React63.createElement(
    TextInput,
    {
      onValue: callAll(
        onInputValueChange && ((val) => onInputValueChange(val.trim())),
        setInputValue,
        (newVal) => {
          if (newVal === "" && selectedItem) {
            selectItem(null);
          }
        }
      ),
      size: size$1,
      prefix,
      suffix,
      ...getInputProps({
        value: inputValue,
        onFocus: callAll(onFocus, () => {
          if (!isOpen) {
            openMenu();
          }
        }),
        ref: forwardedRef,
        ...inputProps
      })
    }
  ), !allowFreeText && /* @__PURE__ */ React63.createElement(
    "button",
    {
      ...getToggleButtonProps({
        type: "button",
        className: "absolute inset-y-0 right-0 flex items-center p-2 text-gray-400",
        disabled: inputProps.disabled
      })
    },
    /* @__PURE__ */ React63.createElement(HiChevronDown, { width: 20, height: 20, "aria-hidden": true, className: "w-5 h-5" })
  )), /* @__PURE__ */ React63.createElement(Root, null, /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: "!z-50",
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg",
            menuClass
          )
        })
      },
      isOpen && (optionData ? optionData.displayedItems.length === 0 ? allowFreeText ? null : /* @__PURE__ */ React63.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React63.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React63.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React63.createElement("div", { onFocus: () => closeMenu() }, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React63.createElement(React63.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React63.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => /* @__PURE__ */ React63.createElement(
          Option,
          {
            key: `${option.value}-${option.index}`,
            ...getItemProps({
              item: option,
              index: option.index,
              disabled: option.disabled
            }),
            leftIcon: option.icon,
            highlighted: option.index === highlightedIndex,
            selected: option === selectedItem,
            label: /* @__PURE__ */ React63.createElement(
              TextHighlight,
              {
                searchWords: [trimmedInput],
                textToHighlight: option.label
              }
            ),
            description: option.description && /* @__PURE__ */ React63.createElement(
              TextHighlight,
              {
                textToHighlight: option.description,
                searchWords: [trimmedInput]
              }
            )
          }
        ))))))
      ) : /* @__PURE__ */ React63.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React63.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var SearchableSelect2 = forwardRefWithGenerics(function SearchableSelectOuter(props, forwardedRef) {
  const isInDialog = useIsInDialog();
  const [mounted, setMounted] = React63.useState(false);
  React63.useEffect(() => {
    setMounted(true);
  }, []);
  return isInDialog && !mounted ? /* @__PURE__ */ React63.createElement("div", { className: clsx("relative", props.wrapperClass) }, /* @__PURE__ */ React63.createElement(
    TextInput,
    {
      className: props.className,
      value: props.value,
      size: props.size,
      prefix: props.prefix,
      suffix: props.suffix,
      id: props.id,
      disabled: true,
      ref: forwardedRef
    }
  )) : /* @__PURE__ */ React63.createElement(SearchableSelectImpl, { ...props, ref: forwardedRef });
});

// src/components/phone-input.tsx
var PhoneInput = React63.forwardRef(function PhoneInput2({ className, value, onValue, defaultCountry = "my", ...props }, forwardedRef) {
  const [countryCode, setCountryCode] = React63.useState(defaultCountry);
  const valueWithoutPrefix = React63.useMemo(() => {
    if (!value) {
      return "";
    }
    const currentCountry = countryMap.get(countryCode);
    const prefix = currentCountry ? currentCountry.dialCode : "";
    if (value.startsWith(prefix)) {
      return value.slice(prefix.length);
    }
    return value;
  }, [value, countryCode]);
  const { inputId } = useFormControl();
  const usedId = props.id || inputId;
  return /* @__PURE__ */ React63.createElement("div", { className: clsx("flex", className) }, /* @__PURE__ */ React63.createElement("div", { className: "w-28 flex-shrink-0" }, /* @__PURE__ */ React63.createElement(
    SearchableSelect2,
    {
      value: countryCode,
      onValue: (newCountryCode) => {
        if (newCountryCode) {
          setCountryCode(newCountryCode);
          const newCountry = countryMap.get(newCountryCode);
          if (newCountry) {
            onValue(newCountry.dialCode + valueWithoutPrefix);
          }
        }
      },
      options: countryOptions,
      id: `${usedId}__prefix`,
      className: "rounded-r-none",
      menuAlignStart: true,
      menuClass: "min-w-[15rem]",
      size: props.size,
      disabled: props.disabled
    }
  )), /* @__PURE__ */ React63.createElement(
    TextInput,
    {
      ...props,
      id: usedId,
      value: valueWithoutPrefix,
      onValue: (inputValue) => {
        const currentCountry = countryMap.get(countryCode);
        const prefix = currentCountry ? currentCountry.dialCode : "";
        onValue(inputValue ? prefix + inputValue : inputValue);
      },
      type: "tel",
      ref: forwardedRef,
      className: "rounded-l-none"
    }
  ));
});
var getSvgUrl = (isoCode) => `https://country-flags-images.s3.amazonaws.com/flags/${isoCode}.svg`;
var countryList = CountryList.getAll().map((flag) => ({
  name: flag.name,
  dialCode: flag.dialCode,
  isoCode: flag.code.toLowerCase()
}));
var countryMap = new Map(countryList.map((country) => [country.isoCode, country]));
var countryOptions = countryList.map((country) => ({
  value: country.isoCode,
  label: country.dialCode || "-",
  description: country.name,
  icon: /* @__PURE__ */ React63.createElement("img", { src: getSvgUrl(country.isoCode), alt: "", className: "h-5 w-5", width: 20, height: 20 })
}));

// src/components/phone-field.tsx
var PhoneField = React63.forwardRef(function PhoneField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(PhoneInput, { ...props, className: clsx("flex-1", props.className), ref: forwardedRef }));
});
var SearchableMultiSelect = forwardRefWithGenerics(function SearchableMultiSelect2({
  value,
  onValue,
  options,
  onInputValueChange,
  allowSelectAll,
  selectAllLabel = "Select all",
  size: size$1,
  placeholder,
  onFocus,
  className,
  ...inputProps
}, forwardedRef) {
  const { inputId } = useFormControl();
  const inputSize = useFormControlSize(size$1);
  const [textInputValue, setTextInputValue] = React63.useState("");
  const trimmedInput = textInputValue.trim();
  const onInputChange = (value2) => {
    setTextInputValue(value2);
    if (onInputValueChange) {
      onInputValueChange(value2.trim());
    }
  };
  const optionData = React63.useMemo(() => {
    return options && sortOptions(options, trimmedInput, {
      allowSelectAll,
      additionalFilter: (opt) => !value.includes(opt.value)
    });
  }, [options, trimmedInput, allowSelectAll, value]);
  const selectedItems = React63.useMemo(
    () => optionData ? value.map((v) => optionData.allItems.find((opt) => opt.value === v)).filter(isDefined) : [],
    [value, optionData]
  );
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setSelectedItems
  } = useMultipleSelection({
    selectedItems,
    itemToString: (i) => i ? i.label : "",
    onSelectedItemsChange: ({ selectedItems: selectedItems2 }) => {
      if (selectedItems2) {
        const items = selectedItems2;
        onValue(items.map((i) => i.value));
      }
    }
  });
  const { isOpen, getInputProps, getItemProps, getMenuProps, highlightedIndex, openMenu } = useCombobox({
    inputValue: textInputValue,
    selectedItem: null,
    itemToString: (i) => i ? i.label : "",
    items: optionData ? optionData.items : [],
    inputId,
    stateReducer: (state, { type, changes }) => {
      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.ItemClick) {
        const nextHighlightedIndex = optionData && optionData.items.length === state.highlightedIndex + 1 ? state.highlightedIndex - 1 : state.highlightedIndex;
        return {
          ...changes,
          isOpen: state.isOpen,
          highlightedIndex: nextHighlightedIndex
        };
      }
      return changes;
    },
    onStateChange: ({ inputValue, type, selectedItem }) => {
      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          onInputChange(inputValue || "");
          break;
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            onInputChange("");
            if (selectedItem.value === SELECT_ALL) {
              if (optionData) {
                const result = selectedItems.slice();
                optionData.items.forEach((item) => {
                  if (item.value !== SELECT_ALL && !result.includes(item)) {
                    result.push(item);
                  }
                });
                setSelectedItems(result);
              }
            } else {
              addSelectedItem(selectedItem);
            }
          }
          break;
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: [
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  const inputRef = React63.useRef();
  const refToApply = useComposedRefs(inputRef, forwardedRef);
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    MultiInputImplWrapper,
    {
      size: inputSize,
      className: clsx("relative", className),
      ref: floatingHelpers.refs.setReference
    },
    selectedItems.map((selectedItem, index) => /* @__PURE__ */ React63.createElement(
      MultiInputBadge,
      {
        key: `selectedItem-${index}`,
        onDismiss: (ev) => {
          ev.stopPropagation();
          removeSelectedItem(selectedItem);
          if (!isOpen) {
            openMenu();
          }
        },
        ...getSelectedItemProps({
          selectedItem,
          index,
          ...inputProps.disabled && {
            disabled: true,
            tabIndex: void 0
          }
        })
      },
      selectedItem.label
    )),
    /* @__PURE__ */ React63.createElement(
      MultiInputImpl,
      {
        ...getInputProps(
          getDropdownProps({
            onFocus: callAll(onFocus, () => {
              if (!isOpen) {
                openMenu();
              }
            }),
            placeholder: selectedItems.length ? void 0 : placeholder,
            ref: refToApply
          })
        ),
        size: inputSize
      }
    )
  ), /* @__PURE__ */ React63.createElement(Root, null, /* @__PURE__ */ React63.createElement(
    "div",
    {
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg"
          )
        })
      },
      isOpen && (optionData ? optionData.displayedItems.length === 0 ? /* @__PURE__ */ React63.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React63.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React63.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React63.createElement("div", null, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React63.createElement(React63.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React63.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => {
          if (option.value === SELECT_ALL) {
            return /* @__PURE__ */ React63.createElement(
              Option,
              {
                key: `${option.value}-${option.index}`,
                ...getItemProps({
                  item: option,
                  index: option.index,
                  disabled: option.disabled || inputProps.disabled
                }),
                highlighted: option.index === highlightedIndex,
                label: selectAllLabel,
                className: "border-b border-gray-200"
              }
            );
          }
          return /* @__PURE__ */ React63.createElement(
            Option,
            {
              key: `${option.value}-${option.index}`,
              ...getItemProps({
                item: option,
                index: option.index,
                disabled: option.disabled || inputProps.disabled
              }),
              leftIcon: option.icon,
              highlighted: option.index === highlightedIndex,
              label: /* @__PURE__ */ React63.createElement(
                TextHighlight,
                {
                  textToHighlight: option.label,
                  searchWords: [trimmedInput]
                }
              ),
              description: option.description && /* @__PURE__ */ React63.createElement(
                TextHighlight,
                {
                  textToHighlight: option.description,
                  searchWords: [trimmedInput]
                }
              )
            }
          );
        })))))
      ) : /* @__PURE__ */ React63.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React63.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var SearchableMultiSelectField = forwardRefWithGenerics(
  function SearchableMultiSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(SearchableMultiSelect, { ...props, ref: forwardedRef }));
  }
);
var SearchableSelectField = React63.forwardRef(function SearchableSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(
    SearchableSelect2,
    {
      ...props,
      wrapperClass: clsx(props.wrapperClass, "flex-1"),
      ref: forwardedRef
    }
  ));
});
var SelectField = forwardRefWithGenerics(function SelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(Select, { ...props, ref: forwardedRef }));
});
var Content10 = ({ children, ...props }) => /* @__PURE__ */ React63.createElement(TooltipPrimitive.Portal, null, /* @__PURE__ */ React63.createElement(
  TooltipPrimitive.TooltipContent,
  {
    ...props,
    style: {
      backgroundColor: "#2D333A",
      boxShadow: `hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px`,
      transformOrigin: "var(--radix-tooltip-content-transform-origin)"
    },
    className: clsx(
      "text-xs px-4 py-2 text-white rounded-lg animate-[scalein_100ms_ease-out]",
      props.className
    )
  },
  children,
  /* @__PURE__ */ React63.createElement(TooltipPrimitive.Arrow, { fill: "#2D333A" })
));
var Tooltip = Object.assign({}, TooltipPrimitive, { Content: Content10 });
var TextTooltip = ({
  children,
  text,
  delayDuration,
  ...contentProps
}) => /* @__PURE__ */ React63.createElement(Tooltip.Root, { delayDuration }, /* @__PURE__ */ React63.createElement(Tooltip.Trigger, { asChild: true, className: "cursor-pointer" }, children), /* @__PURE__ */ React63.createElement(Tooltip.Content, { sideOffset: 8, ...contentProps }, text));

// src/components/sidebar.tsx
var Sidebar = ({
  variant = "gray",
  width,
  header,
  items,
  selectedKey,
  renderLink,
  onNavigate,
  className
}) => {
  const [containerRef] = useAutoAnimate({
    duration: 150
  });
  React63.useEffect(() => {
    const styleId = "sidebar-no-scrollbar-style";
    if (!document.getElementById(styleId)) {
      const styleEl = document.createElement("style");
      styleEl.id = styleId;
      styleEl.textContent = `
				.sidebar-container::-webkit-scrollbar {
					display: none !important;
					width: 0 !important;
					background: transparent !important;
				}
				.sidebar-container {
					scrollbar-width: none !important;
					-ms-overflow-style: none !important;
				}
			`;
      document.head.appendChild(styleEl);
    }
  }, []);
  return /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: clsx(
        "relative flex flex-col flex-shrink-0 transition-all h-full",
        {
          gray: "bg-secondary-100",
          primary: "bg-primary-600"
        }[variant],
        width && {
          collapsed: "w-[4.5rem]",
          expanded: "w-72",
          full: "w-full"
        }[width],
        className
      )
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        className: "flex-1 flex flex-col gap-2 p-4 overflow-y-auto scrollbar-hide sidebar-container no-scrollbar",
        ref: containerRef,
        style: {
          scrollbarWidth: "none",
          msOverflowStyle: "none"
        }
      },
      header,
      items.map((item, index) => /* @__PURE__ */ React63.createElement(
        SidebarItem,
        {
          item,
          selectedKey,
          collapsed: width === "collapsed",
          variant,
          renderLink,
          onNavigate,
          key: item.key || index
        }
      ))
    )
  );
};
var SidebarItem = (props) => {
  const { icon, name, label = name, route, children: childItems } = props.item;
  const [expanded, toggle] = React63.useReducer(
    (prevState) => !prevState,
    props.selectedKey === route || !!childItems && childItems.some((child) => child.route === props.selectedKey)
  );
  const isActive = !!route && route === props.selectedKey;
  const hasChildren = !!childItems && childItems.length > 0;
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, route && !hasChildren ? /* @__PURE__ */ React63.createElement(
    NavLink,
    {
      item: props.item,
      isActive,
      variant: props.variant,
      collapsed: props.collapsed,
      renderLink: props.renderLink
    }
  ) : props.collapsed ? /* @__PURE__ */ React63.createElement(
    SidebarMenuItem,
    {
      item: props.item,
      variant: props.variant,
      selectedKey: props.selectedKey,
      onNavigate: props.onNavigate,
      root: true
    }
  ) : /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    "button",
    {
      onClick: toggle,
      className: clsx(
        getLinkClass(props.variant, isActive, props.collapsed),
        "justify-between min-h-[40px]"
      ),
      type: "button"
    },
    /* @__PURE__ */ React63.createElement("span", { className: clsx("flex-1 flex items-center gap-3 w-full") }, React63.isValidElement(icon) ? React63.cloneElement(icon, {
      className: clsx(
        "w-6 h-6 flex-shrink-0 text-inherit",
        icon.props.className
      ),
      width: 24,
      height: 24
    }) : icon, /* @__PURE__ */ React63.createElement(
      "span",
      {
        className: clsx(
          "flex-1 text-left truncate transition-all",
          props.collapsed && "sr-only"
        )
      },
      label
    )),
    !props.collapsed && /* @__PURE__ */ React63.createElement(
      HiChevronDown,
      {
        className: clsx(
          "w-5 h-5 transition-transform",
          expanded ? "rotate-180" : "rotate-0"
        ),
        width: 20,
        height: 20,
        "aria-hidden": true
      }
    )
  ), expanded && childItems && hasChildren && /* @__PURE__ */ React63.createElement("div", { className: "pl-4" }, childItems.map((item, i) => /* @__PURE__ */ React63.createElement(
    SidebarItem,
    {
      item,
      selectedKey: props.selectedKey,
      variant: props.variant,
      renderLink: props.renderLink,
      onNavigate: props.onNavigate,
      key: item.key || i
    }
  )))));
};
var SidebarMenuItem = (props) => {
  const { item } = props;
  let hasActiveChild = false;
  const contentItems = item.children?.map((child, index) => {
    const { route, label } = child;
    if (route) {
      const isActive = route === props.selectedKey;
      if (isActive) {
        hasActiveChild = true;
      }
      return /* @__PURE__ */ React63.createElement(
        Menu.Item,
        {
          onSelect: () => props.onNavigate(route),
          className: clsx(isActive ? "bg-primary-500" : "", "min-h-[36px] py-2"),
          key: route
        },
        label
      );
    }
    if (child.children && Array.isArray(child.children) && child.children.length > 0) {
      return /* @__PURE__ */ React63.createElement(
        SidebarMenuItem,
        {
          item: child,
          selectedKey: props.selectedKey,
          variant: props.variant,
          onNavigate: props.onNavigate,
          key: `sub-${index}`
        }
      );
    }
    return null;
  });
  if (props.root) {
    return /* @__PURE__ */ React63.createElement(Menu.Root, null, /* @__PURE__ */ React63.createElement(TextTooltip, { text: item.label, side: "right" }, /* @__PURE__ */ React63.createElement(
      Menu.Trigger,
      {
        className: clsx(
          getLinkClass(props.variant, hasActiveChild, true),
          "data-[state=open]:bg-primary-500 data-[state=open]:text-white"
        )
      },
      React63.isValidElement(item.icon) ? React63.cloneElement(item.icon, {
        className: clsx("w-6 h-6 text-inherit", item.icon.props.className),
        width: 24,
        height: 24
      }) : item.icon,
      /* @__PURE__ */ React63.createElement("span", { className: "sr-only" }, item.label)
    )), /* @__PURE__ */ React63.createElement(Menu.Portal, null, /* @__PURE__ */ React63.createElement(Menu.Content, { side: "right", sideOffset: 2, align: "start", alignOffset: -2 }, /* @__PURE__ */ React63.createElement(Menu.Label, { className: "text-xs px-3 py-1 font-medium text-gray-600" }, item.label), contentItems)));
  } else {
    return /* @__PURE__ */ React63.createElement(Menu.Sub, null, /* @__PURE__ */ React63.createElement(Menu.SubTrigger, { className: "flex justify-between items-center gap-2 min-h-[36px] py-2" }, item.label, /* @__PURE__ */ React63.createElement(HiChevronRight, null)), /* @__PURE__ */ React63.createElement(Menu.SubContent, null, contentItems));
  }
};
var NavLink = React63.forwardRef(function NavLink2({ item, isActive, collapsed, variant, renderLink }, forwardedRef) {
  const { label = item.name } = item;
  const content = renderLink({
    to: item.route,
    className: getLinkClass(variant, isActive, collapsed),
    ref: forwardedRef,
    children: /* @__PURE__ */ React63.createElement(React63.Fragment, null, React63.isValidElement(item.icon) ? React63.cloneElement(item.icon, {
      className: clsx("w-6 h-6 flex-shrink-0", item.icon.props.className),
      width: 24,
      height: 24
    }) : item.icon, /* @__PURE__ */ React63.createElement("span", { className: clsx("flex-1 truncate transition-all", collapsed && "sr-only") }, label))
  });
  return collapsed ? /* @__PURE__ */ React63.createElement(TextTooltip, { text: item.label, side: "right" }, content) : content;
});
var getLinkClass = (variant, isActive, rounded) => clsx(
  "w-full flex items-center gap-3 py-2 text-sm overflow-hidden min-h-[40px]",
  "focus:outline-none focus-visible:ring focus-visible:ring-primary-200",
  {
    primary: clsx(
      "hover:bg-primary-800",
      isActive ? "text-white bg-primary-700" : "text-gray-100"
    ),
    gray: clsx(
      "transition-colors hover:bg-primary-600",
      isActive ? "text-white bg-primary-500" : "hover:text-white"
    )
  }[variant],
  rounded ? "rounded-full px-2" : "rounded-md px-3"
);
var StatsCard = ({ items, isLoading, ...props }) => {
  return /* @__PURE__ */ React63.createElement(Card2, { ...props, className: clsx("@container", isLoading && "animate-pulse", props.className) }, /* @__PURE__ */ React63.createElement("dl", { className: "flex flex-col @md:flex-row px-5 @md:px-0 @md:py-5 divide-y @md:divide-y-0 @md:divide-x" }, items.map((item, index) => /* @__PURE__ */ React63.createElement("div", { className: "flex-1 py-5 @md:py-0 @md:px-5", key: index }, /* @__PURE__ */ React63.createElement("dt", { className: "text-sm text-gray-500" }, item.label), /* @__PURE__ */ React63.createElement("dd", { className: "text-2xl mt-1 font-semibold whitespace-nowrap" }, isLoading ? /* @__PURE__ */ React63.createElement(Skeleton, { heightClass: "h-8" }) : item.value)))));
};
var Switch = React63.forwardRef(function Switch2({ isLoading, ...props }, forwardedRef) {
  const { inputId } = useFormControl();
  return /* @__PURE__ */ React63.createElement(
    Primitive8.Root,
    {
      ...props,
      id: props.id || inputId,
      className: clsx(
        "w-[42px] h-[25px] rounded-full transition-colors data-[state=checked]:bg-primary-500",
        "focus:outline-none focus-visible:ring focus-visible:ring-primary-300",
        props.disabled ? "bg-gray-300 cursor-not-allowed" : "bg-gray-200",
        isLoading && "animate-pulse",
        props.className
      ),
      ref: forwardedRef
    },
    /* @__PURE__ */ React63.createElement(
      Primitive8.SwitchThumb,
      {
        className: clsx(
          "block w-[21px] h-[21px] rounded-full translate-x-[2px] transition-transform data-[state=checked]:translate-x-[19px]",
          props.disabled ? "bg-gray-50" : "bg-white"
        )
      },
      isLoading && /* @__PURE__ */ React63.createElement(Spinner, null)
    )
  );
});
var SwitchField = React63.forwardRef(
  function SwitchField2({ id, status, label, layout, hint, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(Switch, { ...props, ref: forwardedRef }), !!hint && /* @__PURE__ */ React63.createElement(Label, { style: { flex: 1, color: "#bbbbbb" } }, hint)));
  }
);
var TableDataContext = createNamedContext(
  {
    borderlessRow: false,
    hoverable: true,
    compact: false
  },
  "TableData"
);
var useTableData = () => React63.useContext(TableDataContext);
var TableImpl = React63.forwardRef(function Table({ borderlessRow = false, children, className, hoverable = true, compact = false, ...rest }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement("div", { className: "overflow-x-auto" }, /* @__PURE__ */ React63.createElement(
    "table",
    {
      className: clsx(
        "table-auto min-w-full divide-y divide-gray-200 dark:divide-gray-700",
        className
      ),
      ...rest,
      ref: forwardedRef
    },
    /* @__PURE__ */ React63.createElement(
      TableDataContext.Provider,
      {
        value: React63.useMemo(
          () => ({
            hoverable,
            compact,
            borderlessRow
          }),
          [hoverable, compact, borderlessRow]
        )
      },
      children
    )
  ));
});
var Thead = React63.forwardRef(
  function Thead2(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      "thead",
      {
        ...props,
        className: clsx("bg-gray-50 dark:bg-gray-700", props.className),
        ref: forwardedRef
      }
    );
  }
);
var Tbody = React63.forwardRef(
  function Tbody2(props, forwardedRef) {
    const { borderlessRow } = useTableData();
    return /* @__PURE__ */ React63.createElement(
      "tbody",
      {
        ...props,
        className: clsx(
          borderlessRow ? "divide-none" : "divide-y divide-gray-200 dark:divide-gray-700",
          props.className
        ),
        ref: forwardedRef
      }
    );
  }
);
var Tr = React63.forwardRef(function Tr2(props, forwardedRef) {
  return /* @__PURE__ */ React63.createElement("tr", { ...props, className: clsx("group", props.className), ref: forwardedRef });
});
var Th = React63.forwardRef(function Th2(props, forwardedRef) {
  const { compact } = useTableData();
  return /* @__PURE__ */ React63.createElement(
    "th",
    {
      ...props,
      className: clsx(
        compact ? "px-3 py-2" : "px-6 py-3",
        "text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-100",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var Td = React63.forwardRef(function Td2(props, forwardedRef) {
  const { compact, hoverable } = useTableData();
  return /* @__PURE__ */ React63.createElement(
    "td",
    {
      ...props,
      className: clsx(
        compact ? "px-3 py-2" : "px-6 py-4",
        hoverable && "group-hover:bg-gray-100/50 group-hover:dark:bg-gray-700/40",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var TableSorter = ({ sort }) => {
  const color = `text-primary-600`;
  const renderSort = () => {
    if (!sort) {
      return /* @__PURE__ */ React63.createElement(FaSort, null);
    }
    return sort === "desc" ? /* @__PURE__ */ React63.createElement(FaSortDown, { className: color }) : /* @__PURE__ */ React63.createElement(FaSortUp, { className: color });
  };
  return /* @__PURE__ */ React63.createElement("div", { className: "inline-flex" }, renderSort());
};
var Table2 = Object.assign(TableImpl, {
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Sorter: TableSorter
});
var PlainButton = React63.forwardRef(function PlainTabButton({ active, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(
    "button",
    {
      type: "button",
      ...props,
      className: clsx(
        "flex justify-center items-center text-sm px-5 py-3 font-medium rounded-t border-b-2 border-transparent transition-colors",
        "data-[state=active]:text-primary-500 data-[state=active]:border-primary-500",
        active && "text-primary-500 !border-primary-500 !border-solid",
        "disabled:text-gray-400",
        // 'focus:outline-none focus-visible:ring focus-visible:ring-primary-200',
        "focus:outline-none",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var PlainList = React63.forwardRef(function PlainTabList(props, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(
    "div",
    {
      ...props,
      className: clsx(
        "flex items-center pt-1 overflow-x-auto overflow-y-hidden border-b border-gray-200",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var Tabs = Object.assign({}, TabsPrimitive, {
  PlainButton,
  PlainList,
  List: React63.forwardRef(
    function StyledTabList({ loop, ...props }, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(TabsPrimitive.List, { loop, asChild: true }, /* @__PURE__ */ React63.createElement(PlainList, { ...props, ref: forwardedRef }));
    }
  ),
  Trigger: React63.forwardRef(
    function StyledTabTrigger({ value, ...props }, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(TabsPrimitive.Trigger, { value, asChild: true }, /* @__PURE__ */ React63.createElement(PlainButton, { ...props, ref: forwardedRef }));
    }
  )
});
var TagImpl = React63.forwardRef(function Tag({ color = "default", ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(
    "span",
    {
      ...props,
      ref: forwardedRef,
      className: clsx(
        "inline-flex items-center py-1 px-2.5 gap-1 text-xs font-medium leading-none whitespace-nowrap rounded-lg",
        colors2[color],
        props.className
      )
    }
  );
});
var colors2 = {
  default: "text-gray-500 border",
  amber: "bg-amber-100 text-amber-800",
  blue: "bg-blue-100 text-blue-800",
  gray: "bg-gray-100 text-gray-800",
  green: "bg-green-100 text-green-800",
  pink: "bg-pink-100 text-pink-800",
  purple: "bg-purple-100 text-purple-800",
  red: "bg-red-100 text-red-800",
  error: "bg-error-100 text-error-300",
  success: "text-success-500 bg-success-100",
  warning: "text-warning-500 bg-warning-100"
};
var Tag2 = Object.assign(TagImpl, {
  colors: Object.keys(colors2)
});
var TextField = React63.forwardRef(function TextField2({ id, status, label, layout, fieldGroupProps, renderError, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout, ...fieldGroupProps }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement("div", { className: "flex flex-col w-full" }, /* @__PURE__ */ React63.createElement(TextInput, { ...props, ref: forwardedRef }), renderError));
});
var SearchableSelectImpl2 = forwardRefWithGenerics(function SearchableSelect3({
  value,
  onValue,
  options,
  loading,
  wrapperClass,
  id,
  onFocus,
  onInputValueChange,
  initialLabel = isString(value) ? value : String(value),
  menuClass,
  size: size$1,
  prefix,
  suffix,
  menuAlignStart,
  allowFreeText,
  ...inputProps
}, forwardedRef) {
  const { inputId: fieldId } = useFormControl();
  const inputId = id || fieldId;
  const [inputValue, setInputValue] = React63.useState(() => String(value));
  const trimmedInput = inputValue.trim();
  const [cachedItem, setCachedItem] = React63.useState(void 0);
  const validCachedItem = cachedItem && (cachedItem.value === value ? cachedItem : void 0);
  const optionData = React63.useMemo(() => {
    const removedOption = void 0;
    if (!options) {
      return removedOption ? sortOptions([], "") : void 0;
    }
    return sortOptions(
      options,
      ""
    );
  }, [options, trimmedInput, validCachedItem]);
  const selectedItem = React63.useMemo(() => {
    if (!value || !optionData) {
      return null;
    }
    return optionData.allItems.find((o) => o.value === value) || null;
  }, [value, optionData]);
  const displayedValue = React63.useMemo(() => {
    const fallbackValue = allowFreeText ? value : "";
    if (!optionData) {
      return fallbackValue;
    }
    const selectedOption = optionData.allItems.find(
      (item) => item.value === value
    );
    return selectedOption ? selectedOption.label : fallbackValue;
  }, [optionData, value, allowFreeText]);
  React63.useEffect(() => {
    setInputValue(displayedValue);
  }, [displayedValue]);
  const {
    isOpen,
    openMenu,
    closeMenu,
    highlightedIndex,
    getInputProps,
    getItemProps,
    getToggleButtonProps,
    getMenuProps,
    selectItem
  } = useCombobox({
    inputValue,
    selectedItem,
    items: optionData && optionData.items || [],
    itemToString: (i) => i ? i.label : "",
    inputId,
    onSelectedItemChange: (changes) => {
      const selectedItem2 = changes.selectedItem;
      if (selectedItem2) {
        onValue(selectedItem2.value, selectedItem2.label);
        setCachedItem(selectedItem2);
      } else {
        onValue("", "");
      }
    },
    onStateChange: (change) => {
      if (allowFreeText) {
        if (change.type === useCombobox.stateChangeTypes.InputBlur) {
          if (inputValue !== displayedValue && inputValue !== value) {
            onValue(inputValue, inputValue);
          }
        }
        if (change.type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
          if (change.inputValue === "") {
            setInputValue("");
            onInputValueChange && onInputValueChange("");
            if (allowFreeText) {
              onValue("", "");
            }
          } else {
            if (inputValue !== displayedValue && inputValue !== value) {
              onValue(inputValue, inputValue);
            }
          }
        }
      } else {
        if (change.type === useCombobox.stateChangeTypes.InputBlur || change.type === useCombobox.stateChangeTypes.InputKeyDownEscape) {
          if (inputValue !== displayedValue) {
            setInputValue(displayedValue);
          }
        }
        if (change.type === useCombobox.stateChangeTypes.InputKeyDownEscape && change.inputValue === "") {
          setInputValue("");
          onInputValueChange && onInputValueChange("");
        }
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: menuAlignStart ? [] : [
      size({
        apply({ rects, elements }) {
          if (rects.reference.width > rects.floating.width) {
            Object.assign(elements.floating.style, {
              width: `${rects.reference.width}px`
            });
          }
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: clsx("relative", wrapperClass),
      ref: floatingHelpers.refs.setReference
    },
    /* @__PURE__ */ React63.createElement(
      TextInput,
      {
        onValue: callAll(
          onInputValueChange && ((val) => onInputValueChange(val.trim())),
          setInputValue,
          (newVal) => {
            if (newVal === "" && selectedItem) {
              selectItem(null);
            }
          }
        ),
        size: size$1,
        prefix,
        suffix,
        ...getInputProps({
          value: inputValue,
          onFocus: callAll(onFocus, () => {
            if (!isOpen) {
              openMenu();
            }
          }),
          ref: forwardedRef,
          ...inputProps
        })
      }
    ),
    !allowFreeText && /* @__PURE__ */ React63.createElement(
      "button",
      {
        ...getToggleButtonProps({
          type: "button",
          className: "absolute inset-y-0 right-0 flex items-center p-2 text-gray-400",
          disabled: inputProps.disabled
        })
      },
      /* @__PURE__ */ React63.createElement(
        HiChevronDown,
        {
          width: 20,
          height: 20,
          "aria-hidden": true,
          className: "w-5 h-5"
        }
      )
    )
  ), /* @__PURE__ */ React63.createElement(Root, null, /* @__PURE__ */ React63.createElement(
    "div",
    {
      className: "!z-50",
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0
      }
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg",
            menuClass
          )
        })
      },
      isOpen && (loading ? /* @__PURE__ */ React63.createElement("div", { className: "w-full flex flex-row items-center justify-center p-4" }, /* @__PURE__ */ React63.createElement(Spinner, { size: 30 })) : optionData ? optionData.displayedItems.length === 0 ? allowFreeText ? null : /* @__PURE__ */ React63.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React63.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React63.createElement(
          DismissableLayer,
          {
            asChild: true,
            disableOutsidePointerEvents: false
          },
          /* @__PURE__ */ React63.createElement("div", { onFocus: () => closeMenu() }, optionData.displayedItems.map((group, gIndex) => /* @__PURE__ */ React63.createElement(React63.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React63.createElement(OptGroupLabel, null, group.groupLabel), group.options.map((option) => /* @__PURE__ */ React63.createElement(
            Option,
            {
              key: `${option.value}-${option.index}`,
              ...getItemProps({
                item: option,
                index: option.index,
                disabled: option.disabled
              }),
              leftIcon: option.icon,
              highlighted: option.index === highlightedIndex,
              selected: option === selectedItem,
              label: /* @__PURE__ */ React63.createElement(
                TextHighlight,
                {
                  searchWords: [trimmedInput],
                  textToHighlight: option.label
                }
              ),
              description: option.description && /* @__PURE__ */ React63.createElement(
                TextHighlight,
                {
                  textToHighlight: option.description,
                  searchWords: [trimmedInput]
                }
              )
            }
          )))))
        )
      ) : /* @__PURE__ */ React63.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React63.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var TextInputSelect = forwardRefWithGenerics(
  function SearchableSelectOuter2(props, forwardedRef) {
    const isInDialog = useIsInDialog();
    const [mounted, setMounted] = React63.useState(false);
    React63.useEffect(() => {
      setMounted(true);
    }, []);
    return isInDialog && !mounted ? /* @__PURE__ */ React63.createElement("div", { className: clsx("relative", props.wrapperClass) }, /* @__PURE__ */ React63.createElement(
      TextInput,
      {
        className: props.className,
        value: props.value,
        size: props.size,
        prefix: props.prefix,
        suffix: props.suffix,
        id: props.id,
        disabled: true,
        ref: forwardedRef
      }
    )) : /* @__PURE__ */ React63.createElement(SearchableSelectImpl2, { ...props, ref: forwardedRef });
  }
);
var TextInputSelectField = React63.forwardRef(function SearchableSelectField3({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(
    TextInputSelect,
    {
      ...props,
      wrapperClass: clsx(props.wrapperClass, "flex-1"),
      ref: forwardedRef
    }
  ));
});
var TextInputMultiSelect = forwardRefWithGenerics(function TextInputMultiSelect2({
  value = [],
  onValue,
  options,
  onInputValueChange,
  allowSelectAll,
  selectAllLabel = "Select all",
  size: size$1,
  placeholder,
  onFocus,
  className,
  loading,
  ...inputProps
}, forwardedRef) {
  const { inputId } = useFormControl();
  const inputSize = useFormControlSize(size$1);
  const [textInputValue, setTextInputValue] = React63.useState("");
  const trimmedInput = textInputValue.trim();
  const onInputChange = (value2) => {
    setTextInputValue(value2);
    if (onInputValueChange) {
      onInputValueChange(value2.trim());
    }
  };
  const optionData = React63.useMemo(() => {
    return options && sortOptions(options, trimmedInput, {
      allowSelectAll,
      additionalFilter: (opt) => !value.includes(opt.value)
    });
  }, [options, trimmedInput, allowSelectAll, value]);
  const selectedItems = React63.useMemo(() => {
    const innerValue = value || [];
    return optionData ? innerValue?.map((v) => optionData.allItems.find((opt) => opt.value === v)).filter(isDefined) : [];
  }, [value, optionData]);
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setSelectedItems
  } = useMultipleSelection({
    selectedItems,
    itemToString: (i) => i ? i.label : "",
    onSelectedItemsChange: ({ selectedItems: selectedItems2 }) => {
      if (selectedItems2) {
        const items = selectedItems2;
        onValue(items?.map((i) => i.value));
      }
    }
  });
  const { isOpen, getInputProps, getItemProps, getMenuProps, highlightedIndex, openMenu } = useCombobox({
    inputValue: textInputValue,
    selectedItem: null,
    itemToString: (i) => i ? i.label : "",
    items: optionData ? optionData.items : [],
    inputId,
    stateReducer: (state, { type, changes }) => {
      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.ItemClick) {
        const nextHighlightedIndex = optionData && optionData.items.length === state.highlightedIndex + 1 ? state.highlightedIndex - 1 : state.highlightedIndex;
        return {
          ...changes,
          isOpen: state.isOpen,
          highlightedIndex: nextHighlightedIndex
        };
      }
      return changes;
    },
    onStateChange: ({ inputValue, type, selectedItem }) => {
      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          onInputChange(inputValue || "");
          break;
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            onInputChange("");
            if (selectedItem.value === SELECT_ALL) {
              if (optionData) {
                const result = selectedItems.slice();
                optionData.items.forEach((item) => {
                  if (item.value !== SELECT_ALL && !result.includes(item)) {
                    result.push(item);
                  }
                });
                setSelectedItems(result);
              }
            } else {
              addSelectedItem(selectedItem);
            }
          }
          break;
      }
    }
  });
  const floatingHelpers = useFloating({
    placement: "bottom-start",
    middleware: [
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ],
    whileElementsMounted: autoUpdate,
    open: isOpen
  });
  const inputRef = React63.useRef();
  const refToApply = useComposedRefs(inputRef, forwardedRef);
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(
    MultiInputImplWrapper,
    {
      size: inputSize,
      className: clsx("relative", className),
      ref: floatingHelpers.refs.setReference
    },
    selectedItems?.map((selectedItem, index) => /* @__PURE__ */ React63.createElement(
      MultiInputBadge,
      {
        key: `selectedItem-${index}`,
        onDismiss: (ev) => {
          ev.stopPropagation();
          removeSelectedItem(selectedItem);
          if (!isOpen) {
            openMenu();
          }
        },
        ...getSelectedItemProps({
          selectedItem,
          index,
          ...inputProps.disabled && {
            disabled: true,
            tabIndex: void 0
          }
        })
      },
      selectedItem.label
    )),
    /* @__PURE__ */ React63.createElement(
      MultiInputImpl,
      {
        ...getInputProps({
          // NOTE: added this tgt for onChange to work
          // But excluded the required because of the value not reflecting
          ...inputProps,
          required: false,
          ...getDropdownProps({
            onFocus: callAll(onFocus, () => {
              if (!isOpen) {
                openMenu();
              }
            }),
            placeholder: selectedItems.length ? void 0 : placeholder,
            ref: refToApply
          })
        }),
        size: inputSize
      }
    )
  ), /* @__PURE__ */ React63.createElement(Root, null, /* @__PURE__ */ React63.createElement(
    "div",
    {
      ref: floatingHelpers.refs.setFloating,
      style: {
        position: floatingHelpers.strategy,
        top: floatingHelpers.y ?? 0,
        left: floatingHelpers.x ?? 0,
        zIndex: 9999999
      }
    },
    /* @__PURE__ */ React63.createElement(
      "div",
      {
        ...getMenuProps({
          className: clsx(
            "max-h-72 overflow-y-auto",
            isOpen && "p-1 bg-white rounded shadow-lg"
          )
        })
      },
      isOpen && (loading ? /* @__PURE__ */ React63.createElement("div", { className: "w-full flex flex-row items-center justify-center p-4" }, /* @__PURE__ */ React63.createElement(Spinner, { size: 30 })) : optionData ? optionData.displayedItems.length === 0 ? /* @__PURE__ */ React63.createElement("div", { className: "px-4 py-2" }, "No results found.") : /* @__PURE__ */ React63.createElement(
        FocusScope,
        {
          asChild: true,
          trapped: false,
          onMountAutoFocus: (ev) => ev.preventDefault(),
          onUnmountAutoFocus: (ev) => ev.preventDefault()
        },
        /* @__PURE__ */ React63.createElement(DismissableLayer, { asChild: true, disableOutsidePointerEvents: false }, /* @__PURE__ */ React63.createElement("div", null, optionData.displayedItems?.map((group, gIndex) => /* @__PURE__ */ React63.createElement(React63.Fragment, { key: gIndex }, group.groupLabel && /* @__PURE__ */ React63.createElement(OptGroupLabel, null, group.groupLabel), group.options?.map((option) => {
          if (option.value === SELECT_ALL) {
            return /* @__PURE__ */ React63.createElement(
              Option,
              {
                key: `${option.value}-${option.index}`,
                ...getItemProps({
                  item: option,
                  index: option.index,
                  disabled: option.disabled || inputProps.disabled
                }),
                highlighted: option.index === highlightedIndex,
                label: selectAllLabel,
                className: "border-b border-gray-200"
              }
            );
          }
          return /* @__PURE__ */ React63.createElement(
            Option,
            {
              key: `${option.value}-${option.index}`,
              ...getItemProps({
                item: option,
                index: option.index,
                disabled: option.disabled || inputProps.disabled
              }),
              leftIcon: option.icon,
              highlighted: option.index === highlightedIndex,
              label: /* @__PURE__ */ React63.createElement(
                TextHighlight,
                {
                  textToHighlight: option.label,
                  searchWords: [trimmedInput]
                }
              ),
              description: option.description && /* @__PURE__ */ React63.createElement(
                TextHighlight,
                {
                  textToHighlight: option.description,
                  searchWords: [trimmedInput]
                }
              )
            }
          );
        })))))
      ) : /* @__PURE__ */ React63.createElement("div", { className: "text-center p-3" }, /* @__PURE__ */ React63.createElement(Spinner, { className: "w-5 h-5 animate-spin inline-block" })))
    )
  )));
});
var TextInputMultiSelectField = forwardRefWithGenerics(function TextInputMultiSelectField2({ id, status, label, layout, ...props }, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(TextInputMultiSelect, { ...props, ref: forwardedRef }));
});
var TimeInputField = React63.forwardRef(
  function TimeInputField2({ id, status, label, layout, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(FieldGroup, { fieldId: id, status, layout }, label && /* @__PURE__ */ React63.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React63.createElement(TimeInput, { ...props }));
  }
);
var StyledToast = React63.forwardRef(function StyledToast2(props, forwardedRef) {
  return /* @__PURE__ */ React63.createElement(
    Primitive9.Root,
    {
      ...props,
      className: clsx(
        "p-3 bg-white shadow rounded [--slide-padding:theme(spacing.3)]",
        "data-[state=open]:animate-[slideinright_150ms_cubic-bezier(0.16,_1,_0.3,_1)] data-[state=closed]:animate-[disappear_100ms_ease-in]",
        "data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-transform",
        "data-[swipe=end]:animate-[swipeout_100ms_ease-out]",
        props.className
      ),
      ref: forwardedRef
    }
  );
});
var Toast = Object.assign({}, Primitive9, {
  Root: StyledToast,
  Title: React63.forwardRef(function StyledToastTitle(props, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      Primitive9.Title,
      {
        ...props,
        className: clsx("text-base font-medium", props.className),
        ref: forwardedRef
      }
    );
  }),
  Description: React63.forwardRef(
    function StyledToastDescription(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        Primitive9.Description,
        {
          ...props,
          className: clsx("text-sm text-gray-600", props.className),
          ref: forwardedRef
        }
      );
    }
  ),
  Viewport: React63.forwardRef(
    function StyledViewport(props, forwardedRef) {
      return /* @__PURE__ */ React63.createElement(
        Primitive9.Viewport,
        {
          ...props,
          className: clsx(
            "z-50 fixed bottom-0 right-0 flex flex-col gap-3 w-96 max-w-[100vw] p-6 outline-none",
            props.className
          ),
          ref: forwardedRef
        }
      );
    }
  ),
  Notification: React63.forwardRef(function ToastNotification({ variant, children, className, ...props }, forwardedRef) {
    return /* @__PURE__ */ React63.createElement(
      StyledToast,
      {
        ...props,
        className: clsx("flex items-start gap-2", className),
        ref: forwardedRef
      },
      /* @__PURE__ */ React63.createElement("div", { className: "flex-shrink-0 pt-1" }, /* @__PURE__ */ React63.createElement(StatusIcon, { type: variant })),
      /* @__PURE__ */ React63.createElement("div", { className: "flex-1" }, children)
    );
  })
});
var useIdUtils = () => {
  const baseId = React63.useId();
  const countRef = React63.useRef(0);
  return {
    baseId,
    getId: () => `${baseId}${countRef.current++}`
  };
};
var useIsMounted = () => {
  const isMountedRef = React63.useRef(false);
  React63.useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
};

// src/utils/array.ts
function isSimilarArray(arrayOne, arrayTwo, keysToCompare) {
  if (arrayOne === arrayTwo) {
    return true;
  }
  if (arrayOne.length !== arrayTwo.length) {
    return false;
  }
  return arrayOne?.every(
    (item, index) => keysToCompare ? keysToCompare?.every((key) => item[key] === arrayTwo[index][key]) : item === arrayTwo[index]
  );
}
function dedupeArrayItem(array) {
  const result = [];
  const seen = /* @__PURE__ */ new Set();
  array.forEach((item) => {
    if (!seen.has(item)) {
      seen.add(item);
      result.push(item);
    }
  });
  return result;
}

// src/utils/assert.ts
var assertExists = (value, errorMessage = "Value is not defined") => {
  if (!value) {
    throw new Error(errorMessage);
  }
};

// src/utils/format-list.ts
var formatStringList = function getImpl(isListFormatSupported) {
  if (isListFormatSupported) {
    const formatter = new Intl.ListFormat("en", { style: "long", type: "conjunction" });
    return function formatStringList2(items) {
      return formatter.format(items);
    };
  }
  return function naiveFormatStringList(items) {
    return items.join(", ");
  };
}(featureCheck.intListFormat);

// src/utils/object.ts
function pick(oriObject, keysToPick) {
  const result = {};
  keysToPick.forEach((key) => {
    result[key] = oriObject[key];
  });
  return result;
}
function omit(oriObject, keysToOmit) {
  const result = Object.assign({}, oriObject);
  keysToOmit.forEach((key) => delete result[key]);
  return result;
}
function pickAndOmit(oriObject, keys) {
  const pick2 = {};
  const omit2 = Object.assign({}, oriObject);
  keys.forEach((key) => {
    if (key in oriObject) {
      pick2[key] = oriObject[key];
    }
    delete omit2[key];
  });
  return {
    picked: pick2,
    omitted: omit2
  };
}
var useDebounce = (value, {
  waitMs = 500,
  onChange
} = {}) => {
  const [dValue, setDValue] = React63.useState(value);
  const onChangeRef = React63.useRef(onChange);
  onChangeRef.current = onChange;
  const isInitial = React63.useRef(true);
  React63.useEffect(() => {
    if (isInitial.current) {
      return;
    }
    const timerId = window.setTimeout(() => {
      setDValue(value);
      if (onChangeRef.current) {
        onChangeRef.current(value);
      }
    }, waitMs);
    return () => window.clearTimeout(timerId);
  }, [value, waitMs]);
  React63.useEffect(() => {
    isInitial.current = false;
  }, []);
  return dValue;
};
var emitter = mitt();
var usePersistedState = (initialState, storageKey) => {
  const getStoredValue = () => {
    const latestValue = window.localStorage.getItem(storageKey);
    return latestValue ? parseSafely(latestValue) : null;
  };
  const [value, setValue] = React63.useState(() => getStoredValue() || initialState);
  const latestValueRef = React63.useRef(value);
  latestValueRef.current = value;
  React63.useEffect(() => {
    const syncStorage = () => {
      const latestValue = getStoredValue();
      if (!isNil(latestValue) && latestValue !== latestValueRef.current) {
        setValue(latestValue);
      }
    };
    syncStorage();
    window.addEventListener("storage", syncStorage);
    const onChange = (data) => {
      if (data.key === storageKey) {
        if (data.value !== latestValueRef.current) {
          setValue(data.value);
        }
      }
    };
    emitter.on("change", onChange);
    return () => {
      window.removeEventListener("storage", syncStorage);
      emitter.off("change", onChange);
    };
  }, [storageKey]);
  const set = React63.useCallback(
    (newValue) => {
      setValue(newValue);
      if (newValue === initialState) {
        window.localStorage.removeItem(storageKey);
      } else {
        window.localStorage.setItem(storageKey, JSON.stringify(newValue));
      }
      emitter.emit("change", {
        key: storageKey,
        value: newValue
      });
    },
    [storageKey]
  );
  return [value, set];
};
var parseSafely = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

// src/utils/webusb-receipt-printer/event-emitter.ts
var EventEmitter = class {
  constructor(device) {
    __publicField(this, "_events");
    this._events = {};
  }
  on(e, f) {
    this._events[e] = this._events[e] || [];
    this._events[e].push(f);
  }
  emit(e, ...args) {
    let fs = this._events[e];
    if (fs) {
      fs.forEach((f) => {
        setTimeout(() => f(...args), 0);
      });
    }
  }
};
var event_emitter_default = EventEmitter;

// src/utils/webusb-receipt-printer/index.ts
var DeviceProfiles = [
  /* POS-8022 and similar printers */
  {
    filters: [{ vendorId: 1155, productId: 22339 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "default"
  },
  /* POS-5805, POS-8360 and similar printers */
  {
    filters: [{ vendorId: 1046, productId: 20497 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "zjiang"
  },
  /* MPT-II and similar printers */
  {
    filters: [{ vendorId: 1155, productId: 22592 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "mpt"
  },
  /* Samsung SRP */
  {
    filters: [{ vendorId: 1049 }, { vendorId: 5380 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "bixolon"
  },
  /* Star */
  {
    filters: [{ vendorId: 1305 }],
    configuration: 1,
    interface: 0,
    /*
    
    			vendorId	productId	productName
    
    									FVP10				star-line
    			0x0519		0x0001		TSP650II			star-line
    									TSP700II			star-line
    									TSP800II			star-line
    									SP700				star-line
    			0x0519 		0x0003		TSP100II			star-graphics
    									TSP100III			star-graphics
    									TSP100IV			star-prnt
    			0x0519		0x0017		mPOP				star-prnt
    			0x0519		0x0019		mC-Label3			star-prnt
    			0x0519		0x000b		BSC10				esc-pos
    			0x0519		0x0011		BSC10BR				esc-pos
    			0x0519		0x001b		BSC10II				esc-pos
    			0x0519		0x0043		SM-S230i			
    			0x0519		0x0047		mC-Print3			star-prnt
    			0x0519		0x0049		mC-Print2			star-prnt
    
    		*/
    language: (device) => {
      let language = "star-line";
      let name = device.productName;
      name = name.replace(/^Star\s+/i, "");
      name = name.replace(
        /^TSP(1|4|6|7|8|10)(13|43)(.*)?$/,
        (m, p1, p2, p3) => "TSP" + p1 + "00" + (p3 || "")
      );
      name = name.replace(
        /^TSP(55|65)(1|4)(.*)?$/,
        (m, p1, p2, p3) => "TSP" + p1 + "0" + (p3 || "")
      );
      name = name.replace(
        /^TSP([0-9]+)(II|III|IV|V|VI)?(.*)?$/,
        (m, p1, p2) => "TSP" + p1 + (p2 || "")
      );
      switch (name) {
        case "TSP100IV":
        case "mPOP":
        case "mC-Label3":
        case "mC-Print3":
        case "mC-Print2":
          language = "star-prnt";
          break;
        case "TSP100":
        case "TSP100II":
        case "TSP100III":
          language = "star-graphics";
          break;
        case "BSC10":
        case "BSC10BR":
        case "BSC10II":
          language = "esc-pos";
          break;
      }
      return language;
    },
    codepageMapping: "star"
  },
  /* Epson */
  {
    filters: [{ vendorId: 1208 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "epson"
  },
  /* Citizen */
  {
    filters: [{ vendorId: 7568 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "citizen"
  },
  /* HP */
  {
    filters: [{ vendorId: 1497 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "hp"
  },
  /* Fujitsu */
  {
    filters: [{ vendorId: 1221 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "epson"
  },
  /* Dtronic */
  {
    filters: [{ vendorId: 4070, productId: 33054 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "epson"
  },
  /* Xprinter */
  {
    filters: [{ vendorId: 8137, productId: 8214 }],
    configuration: 1,
    interface: 0,
    language: "esc-pos",
    codepageMapping: "xprinter"
  }
];
var ReceiptPrinterDriver = class {
};
var _emitter, _device, _profile, _endpoints, _open, open_fn, _evaluate, evaluate_fn, _read, read_fn;
var WebUSBReceiptPrinter = class extends ReceiptPrinterDriver {
  constructor() {
    super();
    __privateAdd(this, _open);
    __privateAdd(this, _evaluate);
    __privateAdd(this, _read);
    __privateAdd(this, _emitter, void 0);
    __privateAdd(this, _device, null);
    __privateAdd(this, _profile, null);
    __privateAdd(this, _endpoints, {
      input: null,
      output: null
    });
    __privateSet(this, _emitter, new event_emitter_default());
    if (!navigator.usb) {
      console.log("WebUSB not supported");
      return;
    }
    navigator.usb.addEventListener("disconnect", (event) => {
      if (__privateGet(this, _device) == event.device) {
        __privateGet(this, _emitter).emit("disconnected");
      }
    });
  }
  async connect() {
    try {
      let device = await navigator.usb.requestDevice({
        filters: DeviceProfiles.flatMap((i) => i.filters)
      });
      if (device) {
        await __privateMethod(this, _open, open_fn).call(this, device);
      }
    } catch (error) {
      console.log("Could not connect! " + error);
    }
  }
  async reconnect(previousDevice) {
    let devices = await navigator.usb.getDevices();
    let device = devices.find((device2) => device2.serialNumber == previousDevice.serialNumber);
    if (!device) {
      device = devices.find(
        (device2) => device2.vendorId == previousDevice.vendorId && device2.productId == previousDevice.productId
      );
    }
    if (device) {
      await __privateMethod(this, _open, open_fn).call(this, device);
    }
  }
  async listen() {
    if (__privateGet(this, _endpoints).input) {
      __privateMethod(this, _read, read_fn).call(this);
      return true;
    }
  }
  async disconnect() {
    if (!__privateGet(this, _device)) {
      return;
    }
    await __privateGet(this, _device).close();
    __privateSet(this, _device, null);
    __privateSet(this, _profile, null);
    __privateGet(this, _emitter).emit("disconnected");
  }
  async print(command) {
    if (__privateGet(this, _device) && __privateGet(this, _endpoints).output) {
      try {
        __privateGet(this, _emitter).emit("print-started", command);
        await __privateGet(this, _device).transferOut(__privateGet(this, _endpoints).output.endpointNumber, command);
        __privateGet(this, _emitter).emit("print-finish", command);
      } catch (e) {
        __privateGet(this, _emitter).emit("print-error", e);
        console.log(e);
      }
    }
  }
  addEventListener(n, f) {
    __privateGet(this, _emitter).on(n, f);
  }
};
_emitter = new WeakMap();
_device = new WeakMap();
_profile = new WeakMap();
_endpoints = new WeakMap();
_open = new WeakSet();
open_fn = async function(device) {
  __privateSet(this, _device, device);
  __privateSet(this, _profile, DeviceProfiles.find(
    (item) => item.filters.some(
      (filter) => filter.vendorId && filter.productId ? filter.vendorId == __privateGet(this, _device)?.vendorId && filter.productId == __privateGet(this, _device).productId : filter.vendorId == __privateGet(this, _device)?.vendorId
    )
  ));
  await __privateGet(this, _device).open();
  await __privateGet(this, _device).selectConfiguration(__privateGet(this, _profile).configuration);
  await __privateGet(this, _device).claimInterface(__privateGet(this, _profile).interface);
  let iface = __privateGet(this, _device).configuration.interfaces.find(
    (i) => i.interfaceNumber == __privateGet(this, _profile).interface
  );
  __privateGet(this, _endpoints).output = iface.alternate.endpoints.find(
    (e) => e.direction == "out"
  );
  __privateGet(this, _endpoints).input = iface.alternate.endpoints.find(
    (e) => e.direction == "in"
  );
  try {
    await __privateGet(this, _device).reset();
  } catch (error) {
    console.log("Could not reset the device connection");
  }
  __privateGet(this, _emitter).emit("connected", {
    type: "usb",
    manufacturerName: __privateGet(this, _device).manufacturerName,
    productName: __privateGet(this, _device).productName,
    serialNumber: __privateGet(this, _device).serialNumber,
    vendorId: __privateGet(this, _device).vendorId,
    productId: __privateGet(this, _device).productId,
    language: await __privateMethod(this, _evaluate, evaluate_fn).call(this, __privateGet(this, _profile).language),
    codepageMapping: await __privateMethod(this, _evaluate, evaluate_fn).call(this, __privateGet(this, _profile).codepageMapping)
  });
};
_evaluate = new WeakSet();
evaluate_fn = async function(expression) {
  if (typeof expression == "function") {
    return await expression(__privateGet(this, _device));
  }
  return expression;
};
_read = new WeakSet();
read_fn = async function() {
  if (!__privateGet(this, _device)) {
    return;
  }
  try {
    const result = await __privateGet(this, _device).transferIn(__privateGet(this, _endpoints).input.endpointNumber, 64);
    if (result instanceof USBInTransferResult) {
      if (result.data.byteLength) {
        __privateGet(this, _emitter).emit("data", result.data);
      }
    }
    __privateMethod(this, _read, read_fn).call(this);
  } catch (e) {
  }
};

export { Alert, AlertDialog, Avatar, Badge2 as Badge, Button, Card2 as Card, Checkbox, CheckboxField, CheckboxGroup, Collapsible, ConfigProvider, DateRangeField, DateRangeSelector, DateTimeField, DateTimeInput, DayField, DayPicker, DaySelector, DescList, Dialog, FieldGroup, FileItem, FileUpload, IconButton, ImageItem, ImageViewer, InputButton, Label, Menu, MultiSelect2 as MultiSelect, MultiSelectField, MultiTextField, MultiTextInput, NumberField2 as NumberField, NumberInput2 as NumberInput, Pagination, PasswordField, PasswordInput, PhoneField, PhoneInput, Popover, Progress, RemoteFileItem, SearchableMultiSelect, SearchableMultiSelectField, SearchableSelect2 as SearchableSelect, SearchableSelectField, Select, SelectField, Sidebar, Skeleton, Spinner, StatsCard, Switch, SwitchField, Table2 as Table, Tabs, Tag2 as Tag, TextField, TextInput, TextInputMultiSelect, TextInputMultiSelectField, TextInputSelect, TextInputSelectField, TextTooltip, TimeInput, TimeInputField, Toast, Tooltip, WebUSBReceiptPrinter, assertExists, callAll, createNamedContext, dedupeArrayItem, flattenOptions, formatDate, formatDateRange, formatDateUtc, formatNumber, formatStringList, isDefined, isFunction, isNil, isNumber, isObject, isPrimitive, isSimilarArray, isString, omit, padEnd, padStart, pick, pickAndOmit, stringRepeat, useConfig, useDebounce, useIdUtils, useIsMounted, usePersistedState };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map